const PT = {
  '1': 'Janeiro',
  '2': 'Fevereiro',
  '3': 'Marchar',
  '4': 'Abril',
  '5': 'Poderia',
  '6': 'Junho',
  '7': 'Julho',
  '8': 'Agosto',
  '9': 'Setembro',
  '10': 'Outubro',
  '11': 'Novembro',
  '12': 'Dezembro',
  'Admob_text7': 'Em Preparação',
  'Admob_text8': 'O Vídeo Ainda Não Está Pronto.',
  'AnchorCenter_biList_interaction_Popup1': 'Você Recebeu Mensagens De \'X\' Usuários',
  'AnchorCenter_biList_interaction_Popup10': 'Exemplo: Você Enviou Mensagens Para 100 Usuários E 50 Deles Responderam. Sua Taxa De Resposta Efetiva (Tre) = 50/100 = 50%',
  'AnchorCenter_biList_interaction_Popup11': 'Taxa De Resposta Efetiva: Contabiliza Apenas As Respostas Recebidas Antes Do Tempo Limite.',
  'AnchorCenter_biList_interaction_Popup12': 'Você Enviou \'X\' Mensagens',
  'AnchorCenter_biList_interaction_Popup13': 'Das \'X\' Mensagens Que Você Enviou, \'N\' Foram Respondidas.',
  'AnchorCenter_biList_interaction_Popup14': 'Percentagem De Suas Mensagens Respondidas (Pv)',
  'AnchorCenter_biList_interaction_Popup15': 'Exemplo: Você Enviou 100 Mensagens E 70 Delas Receberam Respostas Efetivas. Sua Taxa De Resposta Efetiva (Pv) = 70/100 = 70%',
  'AnchorCenter_biList_interaction_Popup16': 'Taxa De Resposta Efetiva: Contabiliza Apenas As Respostas Recebidas Antes Do Tempo Limite.',
  'AnchorCenter_biList_interaction_Popup2': 'Você Respondeu A \'N\' Dos \'X\' Usuários Que Lhe Enviaram Mensagens.',
  'AnchorCenter_biList_interaction_Popup3': 'Exemplo: Você Recebeu Mensagens De 100 Usuários E Respondeu Efetivamente A 90 Deles. Sua Taxa De Resposta Efetiva (Tre) = 90/100 = 90%',
  'AnchorCenter_biList_interaction_Popup4': 'Percentagem De Respostas Às Mensagens (Uv)',
  'AnchorCenter_biList_interaction_Popup5': 'Taxa De Resposta Efetiva: Contabiliza Apenas Os Usuários Que Receberam Resposta Antes Do Tempo Limite.',
  'AnchorCenter_biList_interaction_Popup6': 'Entendi',
  'AnchorCenter_biList_interaction_Popup7': 'Você Enviou Mensagens Para \'X\' Usuários',
  'AnchorCenter_biList_interaction_Popup8': 'De \'X\' Usuários Com Quem Você Trocou Mensagens, \'N\' Responderam A Você.',
  'AnchorCenter_biList_interaction_Popup9': 'Percentagem De Utilizadores Que Responderam (Uv)',
  'AnchorCenter_biList_interaction_text1': 'Interação',
  'AnchorCenter_biList_interaction_text10': 'Suas Mensagens Respondidas (Uv)',
  'AnchorCenter_biList_interaction_text11': 'Taxa De Resposta (Uv)',
  'AnchorCenter_biList_interaction_text12': 'Mensagens Enviadas (Pv)',
  'AnchorCenter_biList_interaction_text13': 'Suas Mensagens Respondidas (Pv)',
  'AnchorCenter_biList_interaction_text14': 'Taxa De Resposta (Pv)',
  'AnchorCenter_biList_interaction_text2': 'Chats Iniciados (Uv)',
  'AnchorCenter_biList_interaction_text3': 'Taxa De Resposta (Uv)',
  'AnchorCenter_biList_interaction_text4': 'Taxa De Resposta (Pv)',
  'AnchorCenter_biList_interaction_text5': 'Taxa De Resposta (Uv)',
  'AnchorCenter_biList_interaction_text6': 'Mensagens Recebidas (Uv)',
  'AnchorCenter_biList_interaction_text7': 'Mensagens Respondidas (Uv)',
  'AnchorCenter_biList_interaction_text8': 'Taxa De Resposta (Uv)',
  'AnchorCenter_biList_interaction_text9': 'Mensagens Enviadas (Uv)',
  'Anonymity_name': 'Anonimato',
  'Charge_Same_1': 'Você Já Enviou O Mesmo Valor De Recarga Para Este Usuário Recentemente E A Transação Foi Bem-Sucedida. Deseja Prosseguir Novamente?',
  'Charge_Same_2': 'Cancelar Pagamento',
  'Charge_Same_3': 'Prosseguir Com O Pagamento',
  'Double_Rewards_text1': 'Torne-Se Svip E Ganhe O Dobro De Recompensas!',
  'EXP': 'Exp',
  'Experience_Card_Statement': '*Os Cartões De Experiência Não Oferecem Esse Benefício.',
  'Hate': 'Odiar',
  'Noble_Change_2': 'Condições De Compra: Patentes Inferiores Podem Comprar Patentes Superiores, Mas Patentes Superiores Não Podem Comprar Patentes Inferiores. Por Exemplo, Se Você For Atualmente Um Conde, Só Poderá Comprar Marquês, Duque Ou Rei.',
  'Noble_Change_3': 'Lógica De Conversão: Se Você Já For Um Aristocrata E Adquirir Outro Nível Aristocrático, O Período De Validade Restante Do Nível Antigo Será Convertido Para O Novo Nível Com Base Na Proporção Do Preço Das Moedas, E O Nível Antigo Se Tornará Inválido.',
  'Noble_Change_4': 'Fórmula Para O Cálculo Do Período De Validade: Período De Validade De Uma Nova Patente Aristocrática Adquirida = Dias Restantes Da Patente Aristocrática Atual * (Preço Da Patente Aristocrática Atual / Preço Da Patente Aristocrática Adquirida) + 30, Sendo O Número Final De Dias Arredondado Para Baixo.',
  'Noble_Change_5': 'Exemplo: Se Você É Atualmente Um Visconde (99990 Moedas/Mês), Com 13 Dias Restantes, E Comprar Um Conde (199990 Moedas/Mês) Hoje, Então, Após O Pagamento, O Período De Validade Do Conde Será De 13 * (99990/199990) + 30 = 6,5 Arredondado Para Baixo + 30 = 36 Dias.',
  'OfficialTaskPic_Level_text1': 'Recompensas Diárias De Diamantes (Mensagem Im)',
  'OfficialTaskPic_Level_text10': 'Recompensa Em Diamantes',
  'OfficialTaskPic_Level_text11': 'Perceber:',
  'OfficialTaskPic_Level_text12': '1. Presente Para Sala De Voz: Incluindo Sala De Voz Normal E Sala De Voz Familiar;',
  'OfficialTaskPic_Level_text13': '2. Recompensa Por Período De Atividade: Após O Término Do Período, O Número De Dias Ativos Será Contabilizado, E A Recompensa Máxima Que Você Pode Obter É De 350 Diamantes;',
  'OfficialTaskPic_Level_text14': '3. Todas As Recompensas Em Diamantes Serão Enviadas Diretamente Para Sua Conta Durante Este Período De Trabalho;',
  'OfficialTaskPic_Level_text15': '4. Cada 100 Diamantes = 1 Usd',
  'OfficialTaskPic_Level_text16': 'Recompensa Diária (Para Presentes Em Chats, Chamadas De Áudio E Vídeo, Combinação De Áudio)',
  'OfficialTaskPic_Level_text17': 'Se Você Receber Diamantes Por Presentes Em Chats, Chamadas De Áudio E Vídeo, Partidas De Áudio E Atingir A Meta Diária, Receberá A Recompensa De Diamantes Correspondente. As Recompensas De Diamantes Serão Adicionadas Automaticamente À Sua Conta No Dia Seguinte.',
  'OfficialTaskPic_Level_text18': 'Recompensa Diária (Para Presentes Em Chats E Salas De Voz)',
  'OfficialTaskPic_Level_text19': 'Remuneração Por Período De Trabalho (Para Chamadas De Áudio E Vídeo)',
  'OfficialTaskPic_Level_text2': 'Nível',
  'OfficialTaskPic_Level_text20': '1. Se Você Receber Diamantes Como Recompensa Por Presentes Em Chats E Salas De Voz E Atingir A Meta Diária, Receberá A Recompensa Correspondente Em Diamantes. As Recompensas Em Diamantes Serão Adicionadas Automaticamente À Sua Conta No Dia Seguinte.',
  'OfficialTaskPic_Level_text21': '2. Se Você Receber Diamantes Por Chamadas De Áudio E Vídeo E Atingir A Meta Até O Final Do Período De Trabalho, Receberá A Recompensa Correspondente Em Diamantes. As Recompensas Em Diamantes Serão Adicionadas Automaticamente À Sua Conta No Dia Seguinte Ao Término Do Período De Trabalho.',
  'OfficialTaskPic_Level_text22': '3. Existem 2 Períodos De Trabalho Que Duram Do Dia 1 Ao Dia 15 De Cada Mês E Do Dia 16 Ao Dia 30/31 De Cada Mês.',
  'OfficialTaskPic_Level_text23': 'Recompensa Diária 1 (Sala De Festa De Áudio E Diamante De Presente Familiar)',
  'OfficialTaskPic_Level_text24': 'Recompensa Diária 2 (Chamada De Voz, Diamante De Combinação De Voz)',
  'OfficialTaskPic_Level_text25': 'Recompensa Por Período De Trabalho (Bate-Papo, Sala De Áudio Para Festas, Chamadas De Voz, Combinação De Áudio)',
  'OfficialTaskPic_Level_text26': '1. Se Você Receber Diamantes Por Presentes Em Chats, Salas De Áudio E Chamadas De Vídeo, Partidas De Áudio E Atingir A Meta Semanal, Receberá A Recompensa De Diamantes Correspondente. As Recompensas De Diamantes Serão Adicionadas Automaticamente À Sua Conta Neste Período De Pagamento.',
  'OfficialTaskPic_Level_text27': '2. Taxa De Pagamento: 100 Diamantes = 1 Usd;',
  'OfficialTaskPic_Level_text28': '3. Os Diamantes Obtidos Como Recompensa Diária Não Serão Contabilizados Para Atingir Essa Meta De Diamantes;',
  'OfficialTaskPic_Level_text29': 'Sistema Oficial De Recompensas Soyou 02.2024',
  'OfficialTaskPic_Level_text3': 'Alvo Diamante',
  'OfficialTaskPic_Level_text30': 'Tarefa Diária 1: Todas As Chamadas + Todos Os Presentes',
  'OfficialTaskPic_Level_text31': 'Missão Diária 2: Responder À Mensagem',
  'OfficialTaskPic_Level_text32': 'Alvo Diamante Diário',
  'OfficialTaskPic_Level_text33': 'Nossa Meta Diária De Diamantes Está Indicada Acima, E Um Dia Em Nosso Sistema De Recompensas É Baseado No Horário Local Da Turquia.',
  'OfficialTaskPic_Level_text4': 'Recompensa Em Diamantes',
  'OfficialTaskPic_Level_text5': 'Recompensas Diárias De Ganhos Em Diamantes (Presentes De Sala De Voz: Sala De Voz Normal + Sala De Voz Familiar)',
  'OfficialTaskPic_Level_text6': 'Recompensas De Renda Diamante Por Período De Trabalho (Mensagem Im + Todos Os Presentes Recebidos)',
  'OfficialTaskPic_Level_text7': 'Recompensas Ativas Durante O Período De Trabalho',
  'OfficialTaskPic_Level_text8': 'Faça Login Por {%s1} Dias E Ganhe {%s2} Diamantes Todos Os Dias',
  'OfficialTaskPic_Level_text9': 'Exigência',
  'OfficialTask_ActiveCard_text1': 'Remuneração Ativa Durante O Período De Trabalho',
  'OfficialTask_ActiveCard_text2': 'Login Cumulativo No Ciclo {%s1} Dias ({%s2}/{%s3})',
  'OfficialTask_ActiveCard_text3': 'Se A Renda Diária De Diamantes Atingir {%s1} 💎, Você Poderá Obter {%s2} 💎. (Hoje: {%s3}/{%s4})',
  'OfficialTask_Card_common_text1': 'Tarefa Oficial',
  'OfficialTask_Card_common_text2': 'Após Completar A Tarefa Oficial De Recompensa, Você Pode Ganhar No Máximo {%s} Diamantes!',
  'OfficialTask_PeriodCard_text1': 'Recompensa Diamante Por Período De Trabalho ({%s1}/{%s2})',
  'OfficialTask_PeriodCard_text2': 'A Recompensa De Diamante Do Período De Trabalho ({%s3}) Atinge {%s1} 💎, Ganhe {%s2} 💎',
  'OfficialTask_dailyCard_text1': 'Recompensas Diárias De Renda De Diamantes ({%s1}/{%s2})',
  'OfficialTask_dailyCard_text2': 'A Renda Diária De Diamantes ({%s1}) Atinge {%s2} 💎, Receba {%s3} 💎',
  'OfficialTask_dailyCard_text3': 'As Recompensas Diárias De Renda De Diamantes ({%s3}) Atingem {%s1} 💎, Ganhe {%s2} 💎',
  'OfficialTask_dailyCard_text4': 'Hora Da Recompensa',
  'OfficialTask_dailyCard_text5': 'Ir',
  'OfficialTask_dailyCard_text6': 'Concluído',
  'OfficialTask_rewardTime_text1': 'Horas',
  'OfficialTask_rewardTime_text2': 'Minutos',
  'Official_website_payment_1': 'Recarga Online Soyou',
  'Official_website_payment_10': '3. Transações Offline Não São Suportadas.',
  'Official_website_payment_11': '4. Não Divulgue As Informações Da Sua Conta Para Ninguém, Por Nenhum Motivo Ou De Nenhuma Forma.',
  'Official_website_payment_12': '5. Portanto, Você Não Será Responsabilizado Por Quaisquer Disputas Entre Usuários E Terceiros.',
  'Official_website_payment_13': '6. Se Houver Algum Problema Com O Carregamento, Entre Em Contato Com O Atendimento Ao Cliente Ou Envie-Nos Um E-Mail.',
  'Official_website_payment_14': 'Combate À Lavagem De Dinheiro',
  'Official_website_payment_15': '1. O Usuário Deve Garantir Que Possui Identidade Legal E Capacidade Para Utilizar Os Serviços Por Nós Oferecidos E Que Não Participará Ou Estará Associado A Qualquer Atividade Criminosa.',
  'Official_website_payment_16': '2. A Conta De Usuário É Para Seu Uso Exclusivo E Pertence Somente A Você. Você Não Pode Transferir, Alugar Ou Ceder Sua Conta A Terceiros.',
  'Official_website_payment_17': '3. O Usuário Deve Garantir Que Todo O Dinheiro Usado Para Recargas Seja Obtido Por Meios Legais E Não Esteja, Em Momento Algum, Associado A Atividades Ou Comportamentos Criminosos.',
  'Official_website_payment_18': 'Método De Pagamento',
  'Official_website_payment_19': 'Atualmente Usando O Canal De Pagamento {%s}',
  'Official_website_payment_2': 'Id De Recarga',
  'Official_website_payment_20': 'Opção De Recarga',
  'Official_website_payment_21': 'Mudar',
  'Official_website_payment_22': 'A Id Da Conta Não Existe!',
  'Official_website_payment_23': 'Ainda Não Há Métodos De Pagamento Disponíveis.',
  'Official_website_payment_24': 'Informe O Método De Pagamento Desejado.',
  'Official_website_payment_25': 'Consultando Resultados De Transações',
  'Official_website_payment_26': 'Resultado Da Recarga A Ser Confirmado',
  'Official_website_payment_27': 'O Resultado Da Recarga Pode Sofrer Atrasos. Por Favor, Acesse O Aplicativo Para Verificar O Histórico De Recargas Da Sua Conta. Caso A Recarga Não Seja Creditada Em Sua Conta Em Um Prazo Razoável, Entre Em Contato Com O Atendimento Ao Cliente.',
  'Official_website_payment_28': 'Atualizar',
  'Official_website_payment_29': 'Recarga Falhou',
  'Official_website_payment_3': 'Insira O Id',
  'Official_website_payment_30': 'Informações De Ajuda:',
  'Official_website_payment_31': '1. Por Favor, Confirme Se O Valor E O Método De Pagamento Estão Corretos, Incluindo Informações Pessoais, Número Do Cartão De Crédito, Período De Validade, Código Cvv, Etc.',
  'Official_website_payment_32': '2. Verifique Se O Saldo Da Conta É Suficiente.',
  'Official_website_payment_33': '3. Verifique Se A Conexão De Rede Está Estável. Às Vezes, Problemas De Rede Podem Causar Falha No Pagamento.',
  'Official_website_payment_34': '4. Tente Usar Outro Método De Pagamento Ou Tente Recarregar Mais Tarde.',
  'Official_website_payment_35': '5. Caso O Problema Persista, Recomenda-Se Entrar Em Contato Com O Serviço De Atendimento Ao Cliente Da Plataforma De Recarga Para Obter Mais Assistência.',
  'Official_website_payment_36': 'Recarga Concluída Com Sucesso',
  'Official_website_payment_37': 'Por Favor, Acesse O Aplicativo Para Visualizar O Histórico De Recargas Da Sua Conta.',
  'Official_website_payment_38': 'Falha No Tempo Limite De Conexão',
  'Official_website_payment_39': 'O Link Expirou. Por Favor, Crie Um Novo Link De Pagamento No Aplicativo.',
  'Official_website_payment_4': 'O Que É Id?',
  'Official_website_payment_5': 'Por Favor, Verifique Primeiro Para Proteger A Privacidade E A Segurança Da Conta.',
  'Official_website_payment_6': 'Consulta',
  'Official_website_payment_7': 'Aviso Aos Usuários',
  'Official_website_payment_8': '1. Não Compre Moedas Soyou Por Meio De Sites Não Oficiais Ou Não Autorizados Para Evitar Disputas Desnecessárias.',
  'Official_website_payment_9': '2. Não Confie Em Nenhuma Informação Não Oficial Publicada Em Outros Sites, Canais De Comunicação Ou Grupos De Discussão. Todas As Informações Sobre O Evento Estão Sujeitas A Anúncio Oficial Por Meio Do Site Oficial Ou Aviso No Sistema.',
  'Privacy Policy': 'Política De Privacidade',
  'Registr_optimization_1': 'Problemas Com O Cadastro E Login',
  'Terms of Service': 'Termos De Serviço',
  'Tvwall_gift_10': 'Condições De Bloqueio De Entrada Da Tela:',
  'Tvwall_gift_11': 'Tela De Bloqueio Por 10 Segundos: Um Desejo Realizado É Concluído E O Valor Do Desejo Está Entre 2000 E 9999 Moedas;',
  'Tvwall_gift_12': 'Tela De Bloqueio Por 20 Segundos: Desejo Realizado E O Valor Do Presente Está Entre 10.000 E 49.999 Moedas;',
  'Tvwall_gift_13': 'Tela De Bloqueio Por 60 Segundos: Desejo Realizado E O Valor Do Desejo Realizado É Superior A 50.000 Moedas.',
  'Tvwall_gift_14': 'Condições Para Aparecer No Muro Mundial Da Tv:',
  'Tvwall_gift_15': 'Registro Comum: Realizou Um Desejo E O Valor Do Presente Está Entre 2000 E 9999 Moedas.',
  'Tvwall_gift_16': 'Recorde De Luxo: Realizou Um Desejo E O Valor Do Presente É Igual Ou Superior A 10.000 Moedas.',
  'Tvwall_gift_17': 'Na Parede Da Tv',
  'Tvwall_gift_18': 'Anônimo Na Parede Da Tv',
  'Tvwall_gift_19': 'Não Na Parede Da Tv',
  'Tvwall_gift_32': 'Será Que A Entrega De Presentes Deveria Ser Mostrada Na Televisão?',
  'Tvwall_gift_33': '(Clique Para Selecionar E Entrar Em Vigor Imediatamente)',
  'Tvwall_gift_9': 'Listas De Desejos De Presentes Completas, No Valor Igual Ou Superior A 2.000 Moedas, Para Serem Exibidas Na Parede Da Tv.',
  'about.badges.0': 'Use O Crachá',
  'about.badges.1': 'Todos Os Distintivos Podem Ser Usados, E Até Cinco Distintivos Podem Ser Usados ​​Ao Mesmo Tempo.',
  'about.badges.2': 'Distintivo De Honra',
  'about.badges.3': 'Os Emblemas Desbloqueados Pelos Valores Mensais Acumulados São Contabilizados No Dia 1º De Cada Mês, Independentemente De O Jogador Os Possuir Ou Não. O Período De Validade É De Um Mês.',
  'about.badges.title': 'Sobre Distintivos',
  'activity.gift.list.contributor': 'Classificação Dos Colaboradores',
  'activity.gift.list.receive': 'Estrelas',
  'activity.gift.list.send': 'Contribuinte',
  'activity.gift.list.stars': 'Ranking de Estrelas',
  'all': 'Todos',
  'anchor.pk.PK.Times': 'Pk Times',
  'anchor.pk.coins': 'Moedas',
  'anchor.pk.countdown': 'Contagem Regressiva',
  'anchor.pk.daily.Ranking': 'Ranking Diário',
  'anchor.pk.days': 'Dias',
  'anchor.pk.duration': 'Duração',
  'anchor.pk.event.end': 'O Evento Terminou.',
  'anchor.pk.exclusive.Sponsor': 'Patrocinador Exclusivo',
  'anchor.pk.hours': 'Horas',
  'anchor.pk.minutes': 'Minutos',
  'anchor.pk.queen': 'Rainha Do Glamour',
  'anchor.pk.queen.daily.rewards': 'Recompensas Diárias Do Ranking Rainha Do Glamour',
  'anchor.pk.queen.total.rewards': 'Recompensas Totais Do Ranking Rainha Do Glamour',
  'anchor.pk.rank': 'Classificação',
  'anchor.pk.rewards': 'Recompensas',
  'anchor.pk.rules': 'Regras',
  'anchor.pk.rules.rewards': 'Regras E Recompensas',
  'anchor.pk.seconds': 'Segundos',
  'anchor.pk.sponsor': 'Patrocinador Exclusivo De Hoje',
  'anchor.pk.sponsor.daily.rewards': 'Recompensas Diárias Exclusivas Do Patrocinador Para O Ranking.',
  'anchor.pk.sponsor.total.rewards': 'Recompensas Exclusivas Para Patrocinadores Com Classificação Total',
  'anchor.pk.target': 'Alvo',
  'anchor.pk.tools.rewards': 'Ferramentas Recompensas',
  'anchor.pk.total.Ranking': 'Classificação Geral',
  'anchor.pk.win.Times': 'Tempos De Vitória',
  'anchor_task_txt1': 'Visite Velhos Amigos (E Receba Respostas Deles) Por {%s1} Vezes E Ganhe {%s2} 💎',
  'anchor_task_txt2': 'O Número De Sessões Com Novos Usuários > 5 Atinge {%s1} Vezes, Obtenha {%s2} 💎',
  'anniversary.celebration.2.collect': 'Coletar',
  'anniversary.celebration.2.go.look': 'Confira Agora Mesmo!',
  'anniversary.celebration.2.next.round': 'Próxima Rodada',
  'anniversary.celebration.2.no.time.yet': 'Ainda Não É Hora.',
  'anniversary.celebration.2.ok': 'Ok',
  'anniversary.celebration.2.ranking.tab.receive': 'Classificação De Charme',
  'anniversary.celebration.2.ranking.tab.send': 'Classificação De Riqueza',
  'anniversary.celebration.2.rewards.tips': 'Para Obter Detalhes Sobre Como Conseguir Moedas E Diamantes, Consulte A Página De Regras.',
  'anniversary.celebration.2.scene.rewards.desc': 'Após Participar Do Desbloqueio Da Cena Atual, Você Poderá Obter As Seguintes Recompensas, E O Mvp Terá Recompensas Adicionais.',
  'anniversary.celebration.2.scene.tips': 'O Consumo De Moedas Em Todas As Plataformas (Exceto Na Parte Do Jogo E No Envio De Pacotes Da Sorte) Deve Atingir O Valor Necessário Para Desbloquear Cenas E Obter Recompensas. Enviar Presentes Limitados Pode Render O Dobro De Pontos!',
  'anniversary.celebration.2.scene.unlock.modal.mvp.tag': 'Mvp Pode Conseguir',
  'anniversary.celebration.2.scene.unlock.modal.title': 'Parabéns Pela Sua Participação Na Descoberta Do Local:',
  'anniversary.celebration.2.scene.unlock.modal.you.can.get': 'Pode Conseguir',
  'anniversary.celebration.2.special.gift.contribution': 'Baú Encantador',
  'anniversary.celebration.2.special.gift.desc': 'Valor De Presente Limitado Acumulado Recebido {%d} Moedas Podem Participar Da Seleção De Estrelas Da Sorte ({%z}/{%m})',
  'anniversary.celebration.2.special.gift.lucky': 'Baú Da Sorte',
  'anniversary.celebration.2.special.gift.title': 'Caixa Bônus',
  'anniversary.celebration.2.special.gift.to.be.drawn': 'A Ser Sorteado',
  'anniversary.celebration.2.special.gift.to.complete': 'Conclua Agora',
  'anniversary.celebration.2.tab.ranking': 'Classificação',
  'anniversary.celebration.2.tab.scene': 'Jornada De Celebração',
  'anniversary.celebration.2.waiting': 'Esperando',
  'annual.draw.1.time': 'Desenhe {N} Vezes',
  'annual.draw.10.time': 'Desenhe {N} Vezes',
  'annual.draw.pop.no.record': 'Ainda Não Há Registro.',
  'annual.draw.pop.no.times': 'Tempos De Saque Insuficientes',
  'annual.draw.pop.oppos': 'Oposto!',
  'annual.draw.pop.rewards.title': 'Parabéns!',
  'annual.draw.pop.to.get': 'Obter',
  'annual.draw.record.text': 'Parabéns! Você Recebeu',
  'annual.ranking.collect': 'Coletar',
  'annual.ranking.confirm': 'Confirmar',
  'annual.ranking.current.tickets': 'Ingressos Atuais',
  'annual.ranking.daily.ranking': 'Classificação Diária',
  'annual.ranking.daily.task': 'Tarefa Diária',
  'annual.ranking.exchange': 'Intercâmbio',
  'annual.ranking.exchange.amount': 'Valor De Câmbio',
  'annual.ranking.exchange.maximum': 'O Valor Da Troca Atingiu O Máximo Hoje.',
  'annual.ranking.fortune.wheel': 'Roda Da Fortuna',
  'annual.ranking.icon': 'Ícone',
  'annual.ranking.limited': 'Limitado',
  'annual.ranking.num': 'Números',
  'annual.ranking.open': 'Abrir',
  'annual.ranking.points': 'Pontos',
  'annual.ranking.record': 'Registro',
  'annual.ranking.return': 'Retornar',
  'annual.ranking.slod.out': 'Vendido',
  'annual.ranking.stock': 'Estoque',
  'annual.ranking.success': 'Sucesso',
  'annual.ranking.surprise.store': 'Loja Surpresa',
  'annual.ranking.task.confirm': 'Tem Certeza De Que Quer Aproveitar O Modo {$count}x Pontos Agora?',
  'annual.ranking.ticket': 'Bilhete',
  'annual.ranking.to.bag': 'Os Itens Trocados Podem Ser Visualizados Na Sacola.',
  'annual.ranking.total.ranking': 'Classificação Geral',
  'annual.ranking.unfinished': 'Inacabado',
  'annual.ranking.union.achor': 'Âncora Anual',
  'annual.ranking.union.agency': 'Agência Anual',
  'annual.ranking.union.id': 'Id Da Agência:',
  'annual.ranking.union.target': 'Alvo',
  'aristocracy.vip.coin.box.sub.title': 'Válido Até',
  'aristocracy.vip.title': 'Aristocracia',
  'biu.biu.building.all.list': 'Classificação Geral',
  'biu.biu.building.can.rush.one': 'Tempos De Pico Restantes: Carro De Nível 1*{$times}',
  'biu.biu.building.can.rush.two': 'Carro Nível 2*{$times}',
  'biu.biu.building.car.detail': 'Detalhes Do Veículo',
  'biu.biu.building.car.double': 'Carros',
  'biu.biu.building.car.not.enough': 'O Número Atual De Veículos É Insuficiente.',
  'biu.biu.building.car.single': 'Carro',
  'biu.biu.building.congra': 'Parabéns!',
  'biu.biu.building.daily.list': 'Classificação Diária',
  'biu.biu.building.detail.coin': '{$month}-{$day} {$hour}:{$min}, Você Recarregou {$coin} Moedas.',
  'biu.biu.building.detail.floors.one': '{$month}-{$day} {$hour}:{$min}, Você Lutou Contra {$count} {$level} {$cars} E Destruiu {$floornumer} {$floor}.',
  'biu.biu.building.floor.double': 'Pisos',
  'biu.biu.building.floor.single': 'Chão',
  'biu.biu.building.get.reward': 'Sua Recompensa!',
  'biu.biu.building.no.lucky': 'Azarado',
  'biu.biu.building.no.records': 'Nenhum Registro',
  'biu.biu.building.no.start': 'Esta Etapa Está Prestes A Começar.',
  'biu.biu.building.one.car': 'Carro De Nível 1',
  'biu.biu.building.ranking.list': 'Classificação',
  'biu.biu.building.recharge': 'Recarregue {$value}Moedas/{$count} Vezes',
  'biu.biu.building.ruls.reward': 'Regra E Recompensas',
  'biu.biu.building.rush.button': 'Vá*{$times}',
  'biu.biu.building.to.collect': 'Ok',
  'biu.biu.building.to.get': 'Obter',
  'biu.biu.building.to.war': 'Ir',
  'biu.biu.building.two.car': 'Carro De Nível 2',
  'blank': '<p>Nenhum Conteúdo Relacionado<p> <p>Por Favor, Verifique Outros Canais<p>',
  'boring': 'Tedioso',
  'break.through.text.14': 'Parabéns! Você Foi Premiado(A)',
  'call': 'Avaliação E Classificação',
  'cancel': 'Cancelar',
  'chatConversation': '💬 Rodadas De Bate-Papo',
  'chatSpeed': 'Velocidade De Resposta',
  'chatSpeed1': 'Minha Velocidade De Resposta Às Mensagens',
  'chat_skill_title': 'Leitura Obrigatória Para Âncoras',
  'chatting': 'Desempenho Do Chat De Mensagens',
  'chatting1': 'Meu Desempenho No Chat',
  'click.refresh': 'Clique Para Atualizar',
  'cms_report_text10': 'Resultado Do Pênalti:',
  'cms_report_text11': 'Histórico De Punições',
  'cms_report_text12': 'Aviso Verbal',
  'cms_report_text13': 'Método De Banimento:',
  'cms_report_text14': 'Motivos Para A Proibição:',
  'cms_report_text15': 'Tempo De Proibição:',
  'cms_report_text16': 'Sensibilidade Política',
  'cms_report_text17': 'Vulgar',
  'cms_report_text18': 'Ataque E Abuso',
  'cms_report_text19': 'Violência Sangrenta',
  'cms_report_text20': 'Anúncio',
  'cms_report_text21': 'Suspeita De Fraude',
  'cms_report_text22': 'Informações Ilegais',
  'cms_report_text23': 'Menor',
  'cms_report_text24': 'Outro',
  'cms_report_text25': 'Confirmação',
  'cms_report_text26': 'Operação Sensível Da Conta, Confirme As Informações Após O Preenchimento.',
  'cms_report_text3': 'Motivo Da Denúncia:',
  'cms_report_text4': 'Detalhes Do Relatório:',
  'cms_report_text5': 'Captura De Tela Do Relatório:',
  'cms_report_text6': '*Por Favor, Verifique As Informações Acima Para Que Possamos Aplicar A Penalidade Por Informações Incorretas.',
  'cms_report_text7': 'Id Do Repórter:',
  'cms_report_text8': 'O Repórter Showid:',
  'cms_report_text9': 'Método De Penalização:',
  'coin.merchant.amount': 'Quantia:',
  'coin.merchant.change.password': 'Mudar Senha',
  'coin.merchant.chat': 'Conversa',
  'coin.merchant.coins.num': 'Inventário De Moedas:',
  'coin.merchant.confirm.again': 'Confirme Novamente A Senha Da Transação.',
  'coin.merchant.confirm.new.again': 'Confirme A Nova Senha Novamente.',
  'coin.merchant.der.amount': 'Valor Da Recarga:',
  'coin.merchant.der.another': 'Recarregar Outra Conta',
  'coin.merchant.der.bind.phone': 'Vincular Número De Celular',
  'coin.merchant.der.bind.phone.placeholder': 'Número De Telefone',
  'coin.merchant.der.change.country': 'Selecione O País',
  'coin.merchant.der.channel': 'Método De Pagamento:',
  'coin.merchant.der.channel.tips': 'Caso Não Consiga Concluir O Pagamento Pelos Métodos Indicados, Entre Em Contato Com A Equipe Oficial Pelo Whatsapp Para Obter Informações Sobre A Compra:',
  'coin.merchant.der.channel.tips.link': 'Cópia',
  'coin.merchant.der.code.tips': 'Caso Não Consiga Receber O Código De Verificação, Entre Em Contato Com A Equipe Oficial Pelo Whatsapp:',
  'coin.merchant.der.complete': 'Recarga Concluída',
  'coin.merchant.der.complete.tips': '{number} Moedas Foram Recarregadas Com Sucesso Para {name}! Faça Login Para Se Divertir Ainda Mais!',
  'coin.merchant.der.current.country': 'Atualmente Estou Usando O Canal De Pagamento De',
  'coin.merchant.der.error': '*Nenhum Resultado Encontrado',
  'coin.merchant.der.fail': 'Falha Ao Recarregar',
  'coin.merchant.der.fail.tips': 'Caso Não Consiga Recarregar Sua Conta, Entre Em Contato Conosco Pelo Endereço Tt_Support@Molelive.Com Se Tiver Alguma Dúvida!',
  'coin.merchant.der.id': 'Id Da Talktalk',
  'coin.merchant.der.modal.title': 'Método De Pagamento',
  'coin.merchant.der.more': 'Recarregue Mais',
  'coin.merchant.der.name': 'Seu Apelido Na Talktalk:',
  'coin.merchant.der.problem': 'Encontrou Problemas?',
  'coin.merchant.der.redeem': 'Resgatar',
  'coin.merchant.der.resend': 'Reenviar',
  'coin.merchant.der.sms.code': 'Insira O Código De Verificação',
  'coin.merchant.der.sms.tips': 'Foi Detectada Uma Atividade Anormal. Para Garantir A Segurança Da Sua Conta, Conclua O Processo De Verificação Abaixo.',
  'coin.merchant.enter': 'Digitar',
  'coin.merchant.enter.amount': 'Insira O Valor',
  'coin.merchant.enter.new.password': 'Digite A Nova Senha',
  'coin.merchant.enter.original.password': 'Digite A Senha Original',
  'coin.merchant.enter.password': 'Digite Sua Senha De Transação',
  'coin.merchant.enter.transaction.password': 'Digite A Senha Da Transação',
  'coin.merchant.enter.user.id': 'Insira O Id Do Usuário',
  'coin.merchant.history': 'História',
  'coin.merchant.history.title': 'Histórico de Operações',
  'coin.merchant.id': 'Eu Ia',
  'coin.merchant.search.id': 'Pesquisar ID',
  'coin.merchant.recharge.summary': 'Recarga',
  'coin.merchant.coin.sales': 'Vendas de Moedas',
  'coin.merchant.list.desc': 'Transferir Moedas Para Este Usuário Equivale A Recarregar, O Que Também Aumentará A Experiência Vip.',
  'coin.merchant.list.title': 'Selecione O Valor',
  'coin.merchant.min.input': 'Quantidade Mínima 1000',
  'coin.merchant.not.found': 'Usuário Não Encontrado',
  'coin.merchant.password.error': 'Senha Incorreta. Tente Novamente.',
  'coin.merchant.password.tips': 'A Senha Deve Ter No Mínimo 8 Caracteres E Deve Conter Letras Maiúsculas, Minúsculas E Números.',
  'coin.merchant.recharge.title': 'Recarga de Vendedor de Moedas',
  'coin.merchant.search': 'Investigação',
  'coin.merchant.set.password': 'Defina Sua Senha De Negociação.',
  'coin.merchant.success': 'Remessa Concluída Com Sucesso',
  'coin.merchant.tips': 'Você Está Prestes A Transferir Um Valor Adicional Para O Usuário. Por Favor, Confirme Novamente O Nome E A Quantidade De Moedas. Esta Operação É Irreversível E A Empresa Não Se Responsabiliza Por Eventuais Erros.',
  'coin.merchant.title': 'Vendedor De Moedas',
  'coin.merchant.to': 'Para:',
  'coin.merchant.transfer': 'Transferir',
  'coin.merchant.transfer.coins': 'Transferir Moedas',
  'coin.merchant.user': 'Usuário',
  'coin.merchant.data': 'Dados',
  'coin.merchant.transaction.times': 'Vezes de Transação',
  'coin.merchant.monthly.current': 'Valor Mensal - {%s}',
  'coin.merchant.monthly.last': 'Valor Mensal - {%s}',
  'coinBack': 'Moedas Devolvidas',
  'coins.battle.draw.drawing.tips': 'Dicas De Desenho',
  'coins.battle.draw.drawing.tips.desc': 'Tempo De Recarga Insuficiente! Recarregue Agora Para Ter Mais Tempo!',
  'coins.battle.draw.drawing.tips.recharge.now': 'Recarregue Agora',
  'coins.battle.draw.no.recharge': 'Só Precisa Recarregar {coinToDrawCount} Moedas Pela Primeira Vez.',
  'coins.battle.draw.recharged': 'Recarga Acumulada De {coinToDrawCount} Moedas: Vezes De Saque +1',
  'coins.battle.draw.remain.times': 'Tempos Restantes: {remainTime} Vezes',
  'coins.battle.draw.total.coins': 'Acumulado:<span class=\'num\'>{totalRechargeCoins}</span>Moedas',
  'coins.battle.entry.btn': 'Recarregue {Cointodrawcount} Moedas Para Obter',
  'coins.battle.entry.desc': 'Você Tem Uma Única Chance De Ganhar Até 1 Milhão De Moedas!',
  'coins.battle.entry.title': 'Benefícios Surpresa',
  'coins.battle.record.complete.task': 'Concluir A Tarefa {N}',
  'coins.battle.record.head.coins.or.tasks': 'Moedas/Tarefas',
  'coins.battle.record.head.time': 'Tempo',
  'coins.battle.record.tab.draw.record': 'Registro De Empate',
  'coins.battle.record.tab.number.of.draws': 'Número De Empates',
  'coins.battle.result.get': 'Pegar',
  'coins.battle.result.prize.pool': 'Receba {N}% Das Moedas Do Prêmio Total.',
  'coins.battle.result.title': 'Parabéns!',
  'coins.battle.rules.not.show.again': 'Não Mostre Novamente.',
  'coins.battle.task.completed': 'Concluído',
  'coins.battle.task.go': 'Ir',
  'coins.battle.task.tips': 'Cada Tarefa Concluída Lhe Garante Uma Vitória Em Um Sorteio.',
  'coins.battle.task.title': 'Área De Exibição De Tarefas',
  'coins.battle.time': 'Tempo',
  'coins.battle.times': 'Vezes',
  'common.Cap.Dating': 'Namorando',
  'common.Cap.Top1': 'Top 1',
  'common.Cap.Uncompleted': 'Incompleto',
  'common.Collect': 'Coletar',
  'common.EXP': 'Exp',
  'common.cap.Close': 'Fechar',
  'common.cap.Coins': 'Moedas',
  'common.cap.Collect': 'Coletar',
  'common.cap.Collected': 'Coletado',
  'common.cap.Confirm': 'Confirmar',
  'common.cap.Congratulations': 'Parabéns',
  'common.cap.Continue': 'Continuar',
  'common.cap.Countdown': 'Contagem Regressiva',
  'common.cap.Countdown.to.Start': 'Contagem Regressiva Para O Início',
  'common.cap.Customer.Server': 'Atendimento Ao Cliente',
  'common.cap.Day': 'Dia',
  'common.cap.Event.To.Start': 'O Evento Está Prestes A Começar.',
  'common.cap.Follow': 'Seguir',
  'common.cap.Go': 'Ir',
  'common.cap.Hour': 'Hora',
  'common.cap.Limited.Gifts': 'Presentes Em Edição Limitada',
  'common.cap.Min': 'Min',
  'common.cap.No': 'Não',
  'common.cap.Ranking': 'Classificação',
  'common.cap.Ranking.click': 'Clique',
  'common.cap.Ranking.click.text': 'Para Conferir Os Diferentes Prêmios',
  'common.cap.Recharge': 'Recarregar',
  'common.cap.Record': 'Registro',
  'common.cap.Rewards': 'Recompensas',
  'common.cap.Rights': 'Todos Os Direitos Reservados Pela Soyo.',
  'common.cap.Rules': 'Regras',
  'common.cap.Sec': 'Seção',
  'common.cap.Start': 'Começar',
  'common.cap.Success': 'Sucesso',
  'common.cap.Successfully.Collected': 'Coletado Com Sucesso',
  'common.cap.Sure': 'Claro',
  'common.cap.Unfortunately.Yes': 'Infelizmente, Sim.',
  'common.cap.Waiting': 'Esperando',
  'common.cap.cancel': 'Cancelar',
  'common.cap.confirm': 'Confirmar',
  'common.cap.event.over': 'O Evento Terminou.',
  'common.cap.month1': 'Janeiro',
  'common.cap.month10': 'Outubro',
  'common.cap.month11': 'Novembro',
  'common.cap.month12': 'Dezembro',
  'common.cap.month2': 'Fevereiro',
  'common.cap.month3': 'Mar',
  'common.cap.month4': 'Abril',
  'common.cap.month5': 'Poderia',
  'common.cap.month6': 'Junho',
  'common.cap.month7': 'Julho',
  'common.cap.month8': 'Agosto',
  'common.cap.month9': 'Setembro',
  'common.cap.my.times': 'Meus Tempos',
  'common.cap.next.round': 'A Próxima Rodada Começará Em Breve…',
  'common.cap.not.remind': 'Chega De Lembretes',
  'common.cap.time': 'Tempo',
  'common.cap.times': 'Vezes',
  'common.cap.update': 'Por Favor, Atualize A Versão Para Usar Os Novos Recursos.',
  'common.number': 'Número',
  'common.recharge.text': 'As Moedas Não São Suficientes. Deseja Recarregar?',
  'common.up.DAYS': 'Dias',
  'common.up.HOURS': 'Horas',
  'common.up.MINS': 'Minutos',
  'common.up.OK': 'Ok',
  'common.up.RECEIVED': 'Encantador',
  'common.up.RULES': 'Regras',
  'common.up.SECS': 'Secs',
  'commonErr': '<p>Sistema Ocupado,<p><p>Tente Novamente Mais Tarde<p>',
  'confirm': 'Confirmar',
  'count': '🙋‍♀️ Mensagens',
  'coupon_pay_txt2': 'Somente Para {%s}',
  'coupon_pay_txt3': 'Cupom De Moedas {%s}%',
  'coupon_pay_txt4': 'Moedas',
  'cp.list.cur.reward.text': 'Desbloqueie Este Local Para Receber As Seguintes Recompensas.',
  'cp.list.limit.tips': 'Enviar Presentes Em Quantidade Limitada Para Atingir O Nível Necessário Pode Desbloquear O Local De Encontro.',
  'cp.list.unlock.contributor': 'Colaborador De Localização',
  'crazy.bulider.build.all': 'Construir Tudo',
  'crazy.bulider.build.n': 'Construir {N} Tempo',
  'crazy.bulider.celebrate.desc': 'Parabéns Pela Construção De {N} Andares!',
  'crazy.bulider.click.celebrate': 'Clique Para Comemorar',
  'crazy.bulider.congura': 'Parabéns!',
  'crazy.bulider.daily': 'Classificação Diária',
  'crazy.bulider.daily.top1': 'Top 1 Diário',
  'crazy.bulider.floors.n': 'Andares{N}',
  'crazy.bulider.get.more': 'Receba Mais',
  'crazy.bulider.luck.gift.desc': 'Envie Um Presente Da Sorte A Cada {N} Moedas = 1{hammerIcon}',
  'crazy.bulider.lucky.desc': 'Escolha 1 Caixa Da Sorte Para Ganhar Um Bônus!',
  'crazy.bulider.lucky.moment': '⭐️Momento De Sorte⭐️',
  'crazy.bulider.model.rewards.desc': 'Você Foi Premiado(A)',
  'crazy.bulider.ok': 'Ok',
  'crazy.bulider.opps': 'Ops!',
  'crazy.bulider.progress.current': 'Atual:{M}={N}',
  'crazy.bulider.progress.target': 'Alvo:',
  'crazy.bulider.ranking': 'Classificação',
  'crazy.bulider.rewards.tab1': 'Recompensas Por Andar',
  'crazy.bulider.rewards.tab2': 'Recompensas Por Classificação',
  'crazy.bulider.share': 'Compartilhar',
  'crazy.bulider.share.desc1': 'Você Já Ultrapassou 90% Dos Construtores! Compartilhe Rapidamente A Visão Atual Com Seus Amigos!',
  'crazy.bulider.share.desc2': '*A Primeira Vez Que Você Compartilhar Com Sucesso No Moment, Poderá Obter Recompensas Exclusivas Para Superconstrutores ↓.',
  'crazy.bulider.share.desc3': '{X} Pessoas Também Começam A Construir Prédios Ao Verem O Seu Momento!',
  'crazy.bulider.share.desc4': 'Obrigado Pela Sua Influência!',
  'crazy.bulider.share.desc5': 'Os Arranha-Céus Estão Sob Meu Controle!',
  'crazy.bulider.share.moment': 'Compartilhar No Momento',
  'crazy.bulider.share.ok': 'Ok',
  'crazy.bulider.share.reward': 'Você Foi Recompensado(A)',
  'crazy.bulider.share.success': 'Sucesso Compartilhado!',
  'crazy.bulider.share.text': '#👷Construtor Louco🚧#\nSuperpoderes Que Afetam O Mundo! 🌏\n{N} Andares Construídos Com Paixão🔥\nRanking Global: #{Rank} 👑\nUma Ótima Oportunidade Para Construir Seu Próprio Arranha-Céu!🏙',
  'crazy.bulider.status.count': 'Contagem Regressiva',
  'crazy.bulider.status.end': 'O Evento Terminou.',
  'crazy.bulider.status.start': 'O Evento Está Prestes A Começar.',
  'crazy.bulider.time.not.desc': 'Tempo De Construção Insuficiente!<br/>O Grande Prêmio Está Esperando Por Você!',
  'crazy.bulider.total': 'Classificação Geral',
  'crazy.bulider.waiting': 'Esperando',
  'crazybuilder.friends.list': 'Lista De Amigos',
  'crazybuilder.friends.list.text': 'As Visitas Diárias Vão Adicionar ❤️ À Cidade Do Seu Amigo.',
  'crazybuilder.friends.list.visit': 'Visita',
  'crazybuilder.king.record': 'Recorde Histórico',
  'crazybuilder.map.enter': 'Cidade',
  'crazybuilder.map.notify.btn': 'Ok',
  'crazybuilder.map.notify.desc': 'Sua Cidade Está Fazendo Sucesso! Continue Construindo Para Atrair Ainda Mais Visitantes!',
  'crazybuilder.map.notify.title': 'Parabéns!',
  'crazybuilder.map.share.btn': 'Compartilhe Agora',
  'crazybuilder.map.share.desc': 'Compartilhe Sua Cidade Da Prosperidade! Convide Seus Amigos Para Comemorarem Juntos!',
  'crazybuilder.map.share.text': '#👷Construtor Maluco🚧#\nHabilidade Suprema Necessária Para Construir Cidades Da Prosperidade! 👑💪\n{N} Andares Estão Gravados Com Meu Nome - {Takma Ad}.🌃\n{M} Favoritos❤️ Concedidos À Minha Cidade Da Prosperidade⭐️\nBem-Vindos À Minha Cidade Para Ver Nossa Diferença😎',
  'crazybuilder.mine.record': 'Meu Registro Atual',
  'crazybuilder.reaching.floors': 'Não Pode Ser Compartilhado Até Atingir Os Andares De Destino.',
  'crazybuilder.toast.reach': 'Alcance {n} Andares E Compartilhe Sua Conquista De Construção! E Receba As Seguintes Recompensas:',
  'cumulativeMiss': 'Total Perdido',
  'currentCycle': 'Ciclo Atual',
  'cycleDiamonds': 'Diamantes Neste Ciclo',
  'daily': 'Diário',
  'delete_account_web': 'Excluir Conta',
  'delete_account_web1': '1. Abra O Aplicativo E Acesse A Página Principal. Clique No Canto Inferior Direito Para Acessar A Aba \"Eu\".',
  'delete_account_web2': '2. Clique Em Configurações Após Acessar A Aba Eu.',
  'delete_account_web3': '3. Após Inserir As Configurações, Clique Em \"Excluir Conta\".',
  'delete_account_web4': '4. Confirme O Primeiro Passo Para Excluir A Conta Permanentemente.',
  'delete_account_web5': '5. Confirme A Segunda Etapa Caso Não Consiga Fazer Login Usando A Mesma Conta.',
  'delete_account_web6': '6. Confirme A Última Etapa Para Excluir Todas As Informações Pessoais Correspondentes.',
  'delete_account_web7': '7. Após Concluir Todas As Etapas Acima, Sua Conta Foi Excluída Com Sucesso, Juntamente Com Todas As Suas Informações Pessoais E Dados Da Conta. Nossa Plataforma Não Armazenará Mais Seus Dados Em Nosso Banco De Dados.',
  'delete_account_web_title': 'Prezado(A) Usuário(A) Do Soyou, Agradecemos Por Usar E Apoiar Nosso Produto. Caso Deseje Excluir Sua Conta, Siga Os Passos Abaixo:',
  'details': 'Detalhes de diamantes',
  'diamond.tab.chat': 'Bater Papo',
  'diamond.tab.voice': 'Festa Da Voz',
  'distributionOfDiamondIncome': 'Distribuição De Renda De Diamantes',
  'dream.city.charm': 'Charme',
  'dream.city.charm.rank': 'Charme',
  'dream.city.city.map': 'Mapa Da Cidade',
  'dream.city.current.coins': 'Moedas Atuais',
  'dream.city.current.diamonds': 'Diamantes Atuais',
  'dream.city.go': 'Ir',
  'dream.city.received': 'Parabéns! Você Recebeu',
  'dream.city.rule.reward': 'Regras E Recompensas',
  'dream.city.rules': 'Regras Do Evento',
  'dream.city.supply.reward': 'Recompensas Da Estação De Abastecimento',
  'dream.city.top5': 'Os 5 Primeiros Usuários Que Chegarem Ao Posto De Suprimentos No Horário Mais Favorável Receberão As Recompensas De Suprimentos.',
  'dream.city.waiting': 'Esperando',
  'dream.city.wealth': 'Fortuna',
  'dream.city.wealth.rank': 'Fortuna',
  'dream.city.will.get': 'Você Receberá',
  'efficient_text_10': 'Se Atingiu O Padrão',
  'efficient_text_11': 'Explicar',
  'efficient_text_12': 'Alcançar O Padrão',
  'efficient_text_13': 'Não Atingiu O Padrão',
  'efficient_text_14': 'Se O Tempo De Uso Do Microfone Se Estender Até O Dia Seguinte, Ele Será Contabilizado Como Tempo Do Dia Anterior.',
  'efficient_text_15': 'Tempo Fora Do Microfone - Tempo No Microfone <%$Min',
  'efficient_text_16': 'Tempo Com O Microfone Desligado - Tempo Com O Microfone Ligado > = %$Min',
  'efficient_text_17': '12/1 9:00:00 O Tempo De Uso Do Microfone Não Atingiu O Padrão, Portanto Não Pode Ser Contabilizado Como Tempo Efetivo.',
  'efficient_text_18': '12/1 23:00:00 O Tempo De Uso Do Microfone Continuou Até 12/2 E Durou 90 Minutos Consecutivos, Portanto, É Contabilizado Como Tempo Durante 12/1.',
  'efficient_text_19': '2. Dias Efetivos Do Quarto',
  'efficient_text_2': 'Tempo Efetivo',
  'efficient_text_20': 'Na Sala De Voz, Todas As Durações Efetivas São Somadas Durante O Dia. %$ Min É Considerado Um Dia Efetivo. Quanto Maior O Número De Dias Válidos, Maior A Atividade, E A Taxa De Atividade Afeta Diretamente As Recompensas Recebidas.',
  'efficient_text_21': 'Tempo Total Efetivo',
  'efficient_text_22': '12/1 3 Vezes No Microfone Durante O Dia: 15 Min + 35 Min + 90 Min. Como 15 Min Não Atende Ao Padrão, O Tempo Válido = 90 + 35 = 125 Min = 02H 05Min',
  'efficient_text_23': '12/1 A Duração Válida Do Dia No Total = 02H 05Min> = %$Min, Que É Contabilizada Como Um Dia Válido',
  'efficient_text_24': '3. Tempo No Microfone',
  'efficient_text_25': 'O Tempo No Microfone Deve Ser O Tempo Efetivo, E Esse Tempo Efetivo Deve Ser Maior Ou Igual A %$Min. O Tempo No Microfone Indica Apenas O Tempo De Conversação No Microfone Na Sala. Será Considerado Tempo Efetivo Quando O Tempo No Microfone For Maior Ou Igual A %$Min, Como Por Exemplo:',
  'efficient_text_26': '4. Detalhes Dos Dados',
  'efficient_text_27': 'Os Dados Serão Exibidos De Acordo Com O Ciclo Selecionado.',
  'efficient_text_28': 'Diamantes',
  'efficient_text_29': 'Bater Papo',
  'efficient_text_30': 'Sala De Voz',
  'efficient_text_31': 'Detalhes',
  'efficient_text_32': 'Data',
  'efficient_text_33': 'Tempo No Microfone',
  'efficient_text_34': 'Tempo Efetivo Da Sala De Voz',
  'efficient_text_35': 'Dias Efetivos Da Sala De Voz',
  'efficient_text_5': 'Dia Efetivo',
  'efficient_text_6': '1. Tempo Válido Na Sala',
  'efficient_text_7': 'Na Sala De Voz, O Tempo Com O Microfone Menos O Tempo Sem Ele É Maior Ou Igual A %$ Minutos E Representa Um Tempo Efetivo De Uso Do Microfone. Incentivamos A Pessoa Que Está Usando O Microfone A Tomar A Iniciativa De Conversar E Interagir Com Os Colegas Por Um Longo Período, Por Exemplo:',
  'efficient_text_8': 'Tempo No Microfone',
  'efficient_text_9': 'Tempo Longe Do Microfone',
  'exchange_text_1': 'Intercâmbio',
  'exchange_text_10': 'Pegar:',
  'exchange_text_13': 'Equilíbrio De Diamantes Insuficiente',
  'exchange_text_14': 'Troca Bem-Sucedida',
  'exchange_text_16': 'A Troca Falhou.',
  'exchange_text_18': 'O Limite De Troca Foi Excedido.',
  'exchange_text_2': 'Saldo De Moedas',
  'exchange_text_3': 'Equilíbrio De Diamantes',
  'exchange_text_4': 'Câmbio Aduaneiro',
  'exchange_text_5': 'Regras De Câmbio',
  'exchange_text_6': 'Taxa De Câmbio',
  'exchange_text_7': 'Limite Diário De Câmbio',
  'exchange_text_8': 'Confirmar A Transação?',
  'exchange_text_9': 'Gasto:',
  'family.battle.new.up.need.s': 'Necessidade De Aumento {N}',
  'family.bronze.family': 'Família Bronze',
  'family.diamond.family': 'Família Diamond',
  'family.diamonds.exch': 'Câmbio De Diamantes',
  'family.division.privilege': 'Divisão E Privilégio De Divisão',
  'family.division.privilege.describe': 'A Divisão É Baseada Na Experiência Mensal, Que É Zerada No Dia 1º De Cada Mês. A Divisão Pode Ser Aprimorada, Mantida Ou Rebaixada. A Manutenção Da Classificação Atual Requer Apenas Atingir 100% Da Experiência Necessária Para A Melhoria Correspondente.',
  'family.exp.content.title.1': 'Como Obter Exp De Família?',
  'family.exp.content.title.2': 'Nível Familiar E Nível De Privilégio',
  'family.exp.content1.text.1': '{%s1} Moedas',
  'family.exp.content1.text.2': '1 Exp',
  'family.exp.content1.text.3': '50 Gemas',
  'family.exp.content1.text.title.1': 'Membros Da Família Enviam Presentes',
  'family.exp.content1.text.title.2': 'Membros Da Família Recebem Presentes',
  'family.exp.content1.text.title.3': 'Concluir Tarefas Familiares',
  'family.exp.table.title.1': 'Exp',
  'family.exp.table.title.2': 'Membro',
  'family.exp.table.title.3': 'Co-Capitão',
  'family.exp.table.title.4': 'Administrador',
  'family.exp.title': 'Experiência Familiar',
  'family.football.no.tips': 'Não Há Mais Dicas Para A Próxima Vez.',
  'family.football.target': 'Recompensas Em Moedas Da Target',
  'family.golden.family': 'Família Dourada',
  'family.king.family': 'Família King',
  'family.label.chatroom': 'Fundo De Sala De Bate-Papo',
  'family.label.familyBg': 'Família Bg',
  'family.label.frame': 'Quadro Familiar',
  'family.label.tag': 'Etiqueta Da Família',
  'family.level.instructions': 'Instruções Para Toda A Família',
  'family.new.diamonds.exch': 'Distintivo',
  'family.silver.family': 'Família Silver',
  'family.task.captain.task': 'Capitão Task',
  'family.task.cumulative': 'Tarefa Cumulativa',
  'family.task.daily.exp': 'Exp Diário',
  'family.task.exp.describe': 'A Experiência Que Você Contribui Para A Família',
  'family.task.family.level': 'O Nível Familiar É Baseado Na Experiência Acumulada. Cada Nível Corresponde Ao Seguinte Privilégio.',
  'family.task.interactive': 'Tarefa Interativa',
  'family.task.invite.join': 'Convide Amigos para se Juntei à Família',
  'family.task.monthly.exp': 'Despesas Mensais',
  'family.task.others': 'Outros',
  'family.task.rules.first': 'Após Cumprir As Condições Do Baú Do Tesouro Familiar, As Recompensas Contidas Nele Serão Abertas Aleatoriamente.',
  'family.task.rules.four': 'As Recompensas Serão Distribuídas Automaticamente Após A Abertura Do Baú Do Tesouro.',
  'family.task.rules.second': 'Os Membros Que Concluírem A Tarefa Antes Da Abertura Do Baú Do Tesouro Receberão Recompensas.',
  'family.task.rules.three': 'Os Itens Serão Distribuídos Para A Sacola De Vencedores, E Outras Recompensas, Como Exp Ou Moedas, Serão Distribuídas Para As Contas.',
  'family.task.tips': 'Conclua Tarefas Nos Primeiros 2 Dias Após Ingressar Na Família Para Ganhar O Dobro De Experiência.',
  'family.task.treasure.chest': 'Baú Do Tesouro Da Família',
  'family.task.treasure.unlocked': 'Se O Número De Membros Atingir %s, O Baú Do Tesouro Da Família Será Destrancado À Meia-Noite Todos Os Dias.',
  'family.task.your.rewards': 'Suas Recompensas',
  'fes.of.sa.catch.btn': 'Capturar ({N})',
  'fes.of.sa.catch.cong.text': 'Se Você Não Conseguiu Pegar O Cordeiro Desta Vez, Enviamos Nossos Melhores Votos E Mais Um Presente!',
  'fes.of.sa.catch.cong.title': 'Parabéns!',
  'fes.of.sa.catch.oops': 'Ops...',
  'fes.of.sa.catch.oops.text': 'Não Conseguiu Receber Recompensas Desta Vez? A Talktalk Deseja-Lhe Boa Sorte! Tente Novamente!',
  'fes.of.sa.catch.suc.text': 'Parabéns! Você Ganhou 1 Cordeiro Grátis!\nCordeiros Grátis Do Aprisco Valem 5 Pontos No Ranking De Cordeiros!',
  'fes.of.sa.catch.suc.title': 'Captura Bem-Sucedida!',
  'fes.of.sa.collect.tools': 'Reúna Os Utensílios Para Assar Cordeiro.',
  'fes.of.sa.combine': 'Combinar',
  'fes.of.sa.count': 'X{N}',
  'fes.of.sa.draw': 'Desenhar*{%d}',
  'fes.of.sa.draw.again': 'Empate Novamente',
  'fes.of.sa.event.gift': 'Brinde Para Evento',
  'fes.of.sa.free': 'Livre!',
  'fes.of.sa.lamb.rewards': 'Brinde Da Lambfold',
  'fes.of.sa.lamb.top': 'Capture Cordeiros De Graça E Ganhe 5 Vezes Mais Pontos De Classificação!',
  'fes.of.sa.not.start': 'O Evento Está Prestes A Começar.',
  'fes.of.sa.ok': 'Ok',
  'fes.of.sa.rank.daily': 'Diário',
  'fes.of.sa.rank.tab1': 'Classificação Do Cordeiro Assado',
  'fes.of.sa.rank.tab2': 'Classificação De Charme',
  'fes.of.sa.rank.total': 'Total',
  'fes.of.sa.ranking': 'Classificação',
  'fes.of.sa.recharge.btn': 'Recarregar',
  'fes.of.sa.records': 'Registro',
  'fes.of.sa.send.btn': 'Enviar',
  'fes.of.sa.tab1': 'Desafio Do Cordeiro Assado',
  'fes.of.sa.tab2': 'Crazy Lambfold',
  'fes.of.sa.ticket.enough': 'Ingressos Insuficientes, Envie Presentes Para Conseguir Mais.',
  'fes.of.sa.time': 'Tempo',
  'fes.of.sa.tip.text': 'Você Tem Mais De {N} Cordeiros Para Combinar, Combinar Agora?',
  'fes.of.sa.unlock.btn': 'Enviar Presente Para Desbloquear',
  'fes.of.sa.wait.lock': 'Aberto!',
  'fishing.activity.achievement': 'Conquista',
  'fishing.activity.bomber': 'Bombardeiro',
  'fishing.activity.cap.Date': 'Data',
  'fishing.activity.cap.Records': 'Registros',
  'fishing.activity.cap.Unfinished': 'Inacabado',
  'fishing.activity.cap.no.record.yet': 'Ainda Não Há Registro.',
  'fishing.activity.catche.single': 'Há Uma Nova Pegadinha!',
  'fishing.activity.catches.more': 'Há Novas Capturas!',
  'fishing.activity.congrats': 'Parabéns!',
  'fishing.activity.energy': 'Energia',
  'fishing.activity.energy.not': 'O Valor Energético É Insuficiente!',
  'fishing.activity.energy.tips': 'As Tarefas Diárias São Atualizadas Às 00:00, Lembre-Se De Coletar As Recompensas A Tempo!',
  'fishing.activity.fish.ticket.not': 'O Cupom Não É Suficiente!',
  'fishing.activity.fishing.big': 'Que Sorte! Encontre Um Peixe Enorme! Clique Na Vara Para Aumentar A Força De Tração E Atingir O Valor Desejado Para Fisgar O Peixe Grande!',
  'fishing.activity.fishnet': 'Rede De Pesca',
  'fishing.activity.gallery': 'Aquário',
  'fishing.activity.gallery.tips': 'Colecione Todos Os Tipos De Peixes Para Receber Muitas Moedas!',
  'fishing.activity.get.more': 'Receba Mais',
  'fishing.activity.go': 'Ir',
  'fishing.activity.new': 'Novo',
  'fishing.activity.not.time': 'Esta Etapa Está Prestes A Começar.',
  'fishing.activity.ok': 'Ok',
  'fishing.activity.put.aquarium': 'Coloque No Aquário',
  'fishing.activity.rank': 'Mestre',
  'fishing.activity.rank.tips': 'Os 5 Melhores Pescadores Do Dia Ganham Recompensas Extras!',
  'fishing.activity.records.coupon': 'Cupom',
  'fishing.activity.records.fish': 'Peixe',
  'fishing.activity.records.others': 'Outros',
  'fishing.activity.slipped.away': 'O Peixe Escapou!',
  'fishing.activity.start.fishing': 'Comece A Pescar',
  'fishing.activity.step1': 'Bem-Vindo! Clique Na Vara De Pescar Para Pescar De Graça!',
  'fishing.activity.step10': 'Ao Capturar Peixes Do Mesmo Tipo, Eles Serão Automaticamente Trocados Por Cupons, Que Podem Ser Usados ​​Para Comprar Itens Na Loja!',
  'fishing.activity.step12': 'Volte Amanhã E Ganhe Mais Um Bomber Grátis!',
  'fishing.activity.step3': 'Ao Obter Um Novo Tipo De Peixe, Você Pode Acender A Luz No Aquário, E Colecionar Todos Os Peixes Pode Render Muitas Moedas Como Recompensa!',
  'fishing.activity.step5': 'Peixe De Novo!',
  'fishing.activity.step8': 'Parabéns Por Ganhar Um Bomber Grátis! Experimente O Poder Do Bomber Agora Mesmo!',
  'fishing.activity.store': 'Loja',
  'fishing.activity.store.buy': 'Comprar',
  'fishing.activity.store.limit': 'Limite:',
  'fishing.activity.store.sold.out': 'Vendido',
  'fishing.activity.try.again': 'Tente Novamente',
  'fishing.activity.you.got': 'Você Foi Premiado(A):',
  'fission.cancel': 'Cancelar',
  'fission.coins': 'Moedas',
  'fission.relation.by.amount': 'Por Valor',
  'fission.relation.by.time': 'Por Tempo',
  'fission.trouble': 'Você Está Tendo Problemas Para Recarregar?',
  'flowWater': 'Detalhes da moeda',
  'gacha.play.1': 'Abrir',
  'gacha.play.2': 'Vezes',
  'gacha.play.3': 'Tempo',
  'game.king.attack': 'Ataque',
  'game.king.award.time': 'Horário De Premiação',
  'game.king.become.nick': 'Parabéns Por {nickname} Se Tornar {Awardname}',
  'game.king.become.self': 'Parabéns Por Se Tornar {Awardname}',
  'game.king.bounds.gold': 'Ouro Bônus',
  'game.king.brave.dragon.island': 'Ilha Do Dragão Valente',
  'game.king.cog': 'Parabéns!',
  'game.king.cur.strogest': 'Atualmente Mais Forte',
  'game.king.current.battle': 'Valor De Batalha Atual',
  'game.king.divide.pool': 'Dividir Pool De Moedas De Ouro*{receiveCoin}',
  'game.king.end.desc': 'Caro Bravo Guerreiro\nParabéns Pela Sua Conquista #{rankings} No Ranking De Guerreiros E Receba As Seguintes Recompensas',
  'game.king.game.king': 'Rei Dos Jogos',
  'game.king.get.rewards': 'Receba Recompensas',
  'game.king.go.center': 'Prezado(A), Seu Poder De Combate É Insuficiente. Por Favor, Participe Do Jogo Para Obtê-Lo.',
  'game.king.king.desc': 'Pontos Desta Rodada',
  'game.king.king.model.coin': 'Batalha Pelo Trono: Obtendo Moedas De Ouro {receiveCoin}',
  'game.king.king.model.times': 'Número De Vezes Que Você Foi O Rei Do Jogo Hoje: {amount}',
  'game.king.king.reward': 'Recompensa Do Rei',
  'game.king.last.warrior': 'Guerreiros Do Último Golpe',
  'game.king.lucky.warrior': 'Guerreiro Sortudo',
  'game.king.no': 'Não',
  'game.king.not.reminder': 'Chega De Lembretes',
  'game.king.other.king.rewards': 'Parabéns A {nickname} Por Ser O {Awardname} E Ganhar {receiveCoin} De Ouro!',
  'game.king.prize.pool': 'Prêmio Total',
  'game.king.reminder': 'Lembrete',
  'game.king.reward': 'Recompensas',
  'game.king.reward.name': 'Nome Da Recompensa',
  'game.king.score': 'Pontuação',
  'game.king.self.king.rewards': 'Parabéns Por Ser O {Awardname} E Receber: {receiveCoin} Moedas De Ouro',
  'game.king.spend.attack': 'Se Deve Gastar {N} De Poder De Combate Para Atacar.',
  'game.king.strongest.warrior': 'O Guerreiro Mais Forte',
  'game.king.tab1': 'Controvérsia Do Trono',
  'game.king.tab2': 'Ilha Do Dragão Valente',
  'game.king.unused.battle': 'Pontos De Batalha Não Utilizados',
  'game.king.warrior.dialog.text': 'Parabéns Por Se Tornar {Awardname} Em {time} E Ganhar: {receiveCoin} Moedas De Ouro!',
  'game.king.warrior.ranking': 'Classificação De Guerreiros',
  'game.king.warrior.rewards': 'Recompensas De Guerreiro',
  'game.king.will.start': 'Prestes A Começar',
  'game.king.yes': 'Sim',
  'game.king.you.is.king': 'Você É O Rei Dos Jogos',
  'game.list.play.now': 'Vá Jogar Jogos',
  'game.list.plus.empyt.list': 'Sem Dados',
  'game.list.rewards.coin.reward.tag': 'Atingir O Valor Limite',
  'game.list.rewards.coin.reward.title': 'Recompensas Em Moedas De Ouro',
  'game.list.rewards.prop.reward.title': 'Recompensas De Prop',
  'game.task.center.get': 'Pegar',
  'game.task.center.received': 'Recebido',
  'gamecenter_ranking_txt6': 'Ranking da Sorte',
  'gamecenter_ranking_txt7': 'Ganhe Mais De 5000 Moedas No Jogo Para Se Qualificar Para A Tabela De Classificação, Sendo Que Os Usuários Que Se Qualificaram Mais Recentemente Ficam Em Posições Mais Altas.',
  'getDiamondsDay': 'Diamantes Hoje:',
  'getDiamondsMonth': 'Diamantes Deste Mês:',
  'gift.list.plus.up.need': 'Precisa De Algo Para Cima',
  'gift.wall.help.text1': 'Os Presentes Que Excederem {num} Moedas Por Vez Aparecerão No Mural De Presentes',
  'gift.wall.help.text2': 'O Presente Que Tiver Mais Moedas Será Exibido Na Primeira Posição Do Ranking.',
  'gift.wall.help.text3': 'O Registro No Mural De Doações Ficará Registrado Por 24 Horas.',
  'gift.wall.title': 'Presentes',
  'hot': 'Quente',
  'hungry.ghost.collect': 'Coletar',
  'hungry.ghost.go.look': 'Confira Agora Mesmo!',
  'hungry.ghost.next.round': 'Próxima Rodada',
  'hungry.ghost.no.time.yet': 'Ainda Não É Hora.',
  'hungry.ghost.ok': 'Ok',
  'hungry.ghost.ranking.tab.receive': 'Classificação De Charme',
  'hungry.ghost.ranking.tab.send': 'Classificação De Riqueza',
  'hungry.ghost.rewards.tips': 'Para Obter Detalhes Sobre Como Conseguir Moedas E Diamantes, Consulte A Página De Regras.',
  'hungry.ghost.scene.rewards.desc': 'Após Participar Do Desbloqueio Da Cena Atual, Você Poderá Obter As Seguintes Recompensas, E O Mvp Terá Recompensas Adicionais.',
  'hungry.ghost.scene.tips': 'Distribua Presentes Limitados Pelo Servidor E Alcance A Quantidade Correspondente De Moedas Para Desbloquear Cenas E Obter Recompensas. Os Mvps Recebem Recompensas Adicionais.',
  'hungry.ghost.scene.unlock.modal.mvp.tag': 'Mvp Pode Conseguir',
  'hungry.ghost.scene.unlock.modal.title': 'Parabéns Pela Sua Participação Na Descoberta Do Local:',
  'hungry.ghost.scene.unlock.modal.you.can.get': 'Pode Conseguir',
  'hungry.ghost.special.gift.contribution': 'Cofre De Contribuições',
  'hungry.ghost.special.gift.desc': 'Valor De Presente Limitado Acumulado Recebido {%d} Moedas Podem Participar Da Seleção De Estrelas Da Sorte ({%z}/{%m})',
  'hungry.ghost.special.gift.lucky': 'Baú Da Sorte',
  'hungry.ghost.special.gift.title': 'Caixa Bônus',
  'hungry.ghost.special.gift.to.be.drawn': 'A Ser Sorteado',
  'hungry.ghost.special.gift.to.complete': 'Conclua Agora',
  'hungry.ghost.tab.ranking': 'Classificação',
  'hungry.ghost.tab.scene': 'Aventura De Halloween',
  'hungry.ghost.waiting': 'Esperando',
  'iftar.congratulations.unlocking': 'Parabéns Pela Sua Participação Na Descoberta Do Prato:',
  'iftar.daily.ranking': 'Classificação Diária',
  'iftar.reward.target': 'Recompensas Em Moedas Da Target',
  'iftar.total.ranking': 'Classificação Geral',
  'iftar.you.received': 'Você Recebeu:',
  'ios_rechargeguide_txt3': 'Moedas De Volta',
  'ios_rechargeguide_txt4': 'Alegar',
  'iosso_wallet_txt1': 'Mais',
  'iosso_wallet_txt2': 'Dobrar',
  'iosso_wallet_txt7': 'Ele Retornará Para A Carteira Em {%s} Segundos.',
  'iosso_wallet_txt8': 'Volte',
  'jungle.e.Total': 'Total',
  'jungle.e.btn.finish': 'Envie Mais Presentes De Evento, Compartilhe Mais Moedas>>',
  'jungle.e.btn.finish.anchor': 'Receba Mais Presentes Ativos E Compartilhe Mais Diamantes!',
  'jungle.e.coin.finish': 'Sintético: Mais Baús Do Tesouro, Obtenha Mais Moedas Do Baú De Super Moedas!',
  'jungle.e.coin.finish.anchor': 'Receba Mais Presentes De Eventos E Compartilhe Mais Diamantes!',
  'jungle.e.coin.reach': 'O Envio De Presentes De Todos Os Membros Atinge {N} Para Desbloquear O Baú De Super Moedas.',
  'jungle.e.coin.reach.anchor': 'Desbloqueie O Super Baú De Diamantes Quando O Número Total De Presentes Recebidos Atingir {N}.',
  'jungle.e.coin.rewards': 'Recompensas Crazy Lambfold',
  'jungle.e.collect.desc': 'Colete Chamas Diariamente Para Ganhar Um Presente Especial E Acumular {N} Vezes Mais Pontos No Ranking De Charme!',
  'jungle.e.collect.title': 'Coleção Chama',
  'jungle.e.combine': 'Combinar',
  'jungle.e.cong.title': 'Parabéns!',
  'jungle.e.daily': 'Diário',
  'jungle.e.day.refresh': 'Atualização Diária Em',
  'jungle.e.divied.coin': 'Atualmente É Possível Compartilhar: {N} Moedas',
  'jungle.e.divied.coin.anchor': 'Atualmente Você Pode Compartilhar {N} Diamantes',
  'jungle.e.draw.again': 'Empate Novamente',
  'jungle.e.draw.time': 'Desenhar*{%d}',
  'jungle.e.event.gift': 'Brinde Para Evento',
  'jungle.e.not.start': 'O Evento Está Prestes A Começar.',
  'jungle.e.ok': 'Ok',
  'jungle.e.pool.amount': 'Valor Total Do Prêmio Acumulado',
  'jungle.e.rechrge': 'Recarregar',
  'jungle.e.record': 'Registro',
  'jungle.e.sec.tab1': 'Classificação Do Cordeiro Assado',
  'jungle.e.sec.tab2': 'Classificação De Charme',
  'jungle.e.self.last': '{N} Do Anterior',
  'jungle.e.send': 'Enviar',
  'jungle.e.send.lock': 'Envie {N} Moedas Adicionais Para Desbloquear',
  'jungle.e.send.lock.anchor': 'Receba {N} Presentes Adicionais Para Desbloquear',
  'jungle.e.tab1': 'Desafio Do Cordeiro Assado',
  'jungle.e.tab2': 'Classificação',
  'jungle.e.tab3': 'Crazy Lambfold',
  'jungle.e.target': 'Limiar: {N}',
  'jungle.e.ticket.enough': 'Cartão De Aventura Insuficiente, Complete Tarefas Para Obter Mais.',
  'jungle.e.time': 'Tempo',
  'jungle.e.times': 'Vezes X{N}',
  'jungle.e.tip.desc': 'Você Tem Mais De {N} Baús Para Sintéticos, Sintéticos Agora?',
  'jungle.e.tool.title': 'Reúna Os Utensílios Para Assar Cordeiro.',
  'jungle.e.treasure': 'X{N}',
  'jungle.e.wating.unlocked': 'Valor Do Prêmio Total A Ser Desbloqueado',
  'jungle.e.win': 'Ganhar',
  'jungle.e.win.desc': 'Parabéns Por Ter Ganho Os Seguintes Prêmios',
  'jungle.e.winner.list': 'Lista De Vencedores',
  'kill.monster.congratulations': 'Parabéns!',
  'lasser.bairam.collect': 'Coletar',
  'lasser.bairam.go.look': 'Confira Agora Mesmo!',
  'lasser.bairam.next.round': 'Próxima Rodada',
  'lasser.bairam.no.time.yet': 'Ainda Não É Hora.',
  'lasser.bairam.ok': 'Ok',
  'lasser.bairam.ranking.tab.receive': 'Classificação De Charme',
  'lasser.bairam.ranking.tab.send': 'Classificação De Riqueza',
  'lasser.bairam.rewards.tips': 'Para Obter Detalhes Sobre Como Ganhar Moedas, Consulte A Página De Regras.',
  'lasser.bairam.scene.rewards.desc': 'Após Participar Do Desbloqueio Da Cena Atual, Você Poderá Obter As Seguintes Recompensas, E O Mvp Terá Recompensas Adicionais.',
  'lasser.bairam.scene.tips': 'Distribua Presentes Limitados Pelo Servidor E Alcance A Quantidade Correspondente De Moedas Para Desbloquear Cenas E Obter Recompensas. Os Mvps Recebem Recompensas Adicionais.',
  'lasser.bairam.scene.unlock.modal.mvp.tag': 'Mvp Pode Conseguir',
  'lasser.bairam.scene.unlock.modal.title': 'Parabéns Pela Sua Participação Na Descoberta Do Local:',
  'lasser.bairam.scene.unlock.modal.you.can.get': 'Pode Conseguir',
  'lasser.bairam.special.gift.contribution': 'Cofre De Contribuições',
  'lasser.bairam.special.gift.desc': 'O Valor Acumulado De Presente Limitado Recebido {%D} Moedas Pode Participar Da Seleção De Estrelas Da Sorte ({%Z}/{%M})',
  'lasser.bairam.special.gift.lucky': 'Baú Da Sorte Do Eid',
  'lasser.bairam.special.gift.title': 'Caixa Bônus',
  'lasser.bairam.special.gift.to.be.drawn': 'A Ser Sorteado',
  'lasser.bairam.special.gift.to.complete': 'Conclua Agora',
  'lasser.bairam.tab.ranking': 'Classificação',
  'lasser.bairam.tab.scene': 'Viagem De Eid Al-Fitr',
  'lasser.bairam.waiting': 'Esperando',
  'level.halo': 'Nível Halo',
  'level.halo.question1.answer1': 'Quanto Mais Alto O Nível, Mais Brilhante O Halo.',
  'level.halo.question1.title': 'Benefícios De Um Alto Nível',
  'level.halo.question2.answer1': 'Quanto Maior O Nível, Mais Exclusivo O Ícone.',
  'level.halo.question2.title': 'Exibição Do Ícone De Nível',
  'level.halo.question3.answer1': 'Suba De Nível Para Ganhar Recompensas Incríveis!',
  'level.halo.question3.title': 'Recompensa Por Subir De Nível',
  'level.halo.question4.answer1': 'Receba Um Presente No Valor De 1 Moeda E Ganhe 1 Ponto De Experiência.\nQuanto Maior A Experiência, Mais Rápido Será O Aprimoramento.',
  'level.halo.question4.title': 'Formas De Subir De Nível',
  'level.user': 'Nível Do Usuário',
  'level.user.icon': 'Ícone',
  'level.user.level': 'Nível',
  'level.user.question1.answer1': 'Você Receberá Itens Especiais E Recompensas.',
  'level.user.question1.title': 'Benefícios De Um Alto Nível',
  'level.user.question2.answer1': 'Converse Na Sala, Jogue, Envie Presentes.',
  'level.user.question2.answer2': 'Complete Tarefas Diárias E Ganhe Experiência Para Subir De Nível.',
  'level.user.question2.answer7': 'Faça Uma Festa No Quarto.',
  'level.user.question2.answer8': 'Envie Um Presente Em Moedas.',
  'level.user.question2.answer9': 'Conclua Tarefas E Ganhe Exp',
  'level.user.question2.title': 'Formas De Subir De Nível',
  'level.user.question3.answer1': 'Quanto Maior O Nível, Mais Exclusivo O Ícone.',
  'level.user.question3.title': 'Exibição Do Ícone De Nível',
  'level.user.question4.answer1': 'Suba De Nível Para Ganhar Recompensas Incríveis!',
  'level.user.question4.title': 'Recompensa Por Subir De Nível',
  'level.user.tips': 'À Medida Que Você Ganha Pontos De Experiência, Seu Nível Aumentará Gradualmente.',
  'level.user.way.up': 'Formas De Aumentar Os Pontos De Experiência:',
  'like': 'Como',
  'loading': 'Carregando...',
  'lucky.darw.coin.draw': 'Empate',
  'lucky.darw.coin.more.times': 'Vezes Custará',
  'lucky.darw.coin.more.will.cost': 'Custará',
  'lucky.darw.coin.one.times': 'Desenhe 1 Custo De Tempo',
  'lucky.darw.coin.one.times.two': 'Selecione E Clique Em Ir.',
  'lucky.darw.end': 'Evento Não Está Em Andamento',
  'lucky.darw.no.times': 'O Número Atual De Sorteios Não É Suficiente, Vá Até A Sala E Envie Presentes.',
  'lucky.darw.number': 'O Número Dos Meus Empates',
  'lucky.darw.ranking': 'Classificação Do Sorteio',
  'lucky.darw.reset.time': 'Contagem Regressiva',
  'lucky.darw.ruls.1': 'Envie Presentes Nas Salas De Bate-Papo E Concorra A Um Sorteio.',
  'lucky.darw.ruls.2': 'A Cada 5000 Moedas Em Presentes, Você Ganha 1 Sorteio.',
  'lucky.darw.ruls.3': 'Por Exemplo: 50.000 Moedas = 10 Sorteios, 100.000 Moedas = 20 Sorteios. Envie Mais Presentes Para Ganhar Mais Sorteios.',
  'lucky.darw.ruls.4': 'Se O Dia Terminar E Você Não Tiver Usado Seus Sorteios, Todos Os Seus Sorteios Serão Zerados Após O Término Do Evento.',
  'lucky.darw.title': 'Sorteio',
  'lucky.darw.use': 'Acessar Usar',
  'lucky.draw.confirm': 'Por Favor, Confirme',
  'lucky.draw.confirm.success': 'Com Sucesso',
  'lucky.draw.confirm.text': 'Tem Certeza De Que Deseja Gastar O Ticketx{%d} Para Trocar?',
  'lucky.draw.exchange.records': 'Registros',
  'lucky.draw.exchange.records.commodity': 'Mercadoria',
  'lucky.draw.exchange.records.consume': 'Consumir',
  'lucky.draw.exchange.records.time': 'Tempo',
  'lucky.draw.exchange.shop': 'Loja De Ingressos',
  'lucky.draw.exchange.shop.exchange': 'Intercâmbio',
  'lucky.draw.exchange.shop.val': 'Valor Das Moedas{%D}',
  'lucky.draw.may.confirm.text': 'Tem Certeza De Que Deseja Gastar {%s} X{%d} Para Desenhar?',
  'lucky.draw.may.draw.draw.times': 'Desenhar*{%d}',
  'lucky.draw.may.draw.draw.tips': 'Enviar Presentes Limitados Por {%d}Moedas Pode Ter A Chance De Sortear',
  'lucky.draw.may.result.tips': '{%s} Será Usado Para Desbloquear O Quebra-Cabeça',
  'lucky.draw.may.rewards.tips': 'Para Obter As Regras Detalhadas Sobre Como Receber As Recompensas, Acesse A Página De Regras.',
  'lucky.draw.may.tab.draw': 'Desenho Mecânico',
  'lucky.draw.may.tab.ranking': 'Classificação',
  'lucky.draw.may.tab.vote': 'Mecha Star',
  'lucky.draw.may.unlock': 'Desbloquear',
  'lucky.draw.may.unlock.all': 'Obrigado Por Desbloquear Todos Os Quebra-Cabeças, Receba Todas As Recompensas!',
  'lucky.draw.may.unlock.some': 'Parabéns Por Desbloquear {%s}%, Pegue Essas Recompensas～',
  'lucky.draw.may.vote': 'Voto',
  'lucky.draw.may.vote.cur.ranking': 'Classificação Atual:{%d}',
  'lucky.draw.may.vote.please.enter.id': 'Por Favor, Insira O Id.',
  'lucky.draw.may.vote.search.tips': 'Somente Os Âncoras Podem Ser Votados.',
  'lucky.draw.may.vote.tips': 'Enviar Presentes Limitados Por {%d} Moedas Pode Obter 1 Ingresso',
  'lucky.draw.may.vote.top3.tips': 'Para Mais Detalhes Sobre As Recompensas, Consulte A Página De Regras.',
  'lucky.draw.may.vote.top3.title': '3 Principais Recompensas',
  'lucky.draw.may.vote.voting.record': 'Histórico De Votação',
  'lucky.draw.may.vote.voting.record.number': 'Número De Votos',
  'lucky.draw.may.vote.voting.record.user': 'Usuário',
  'lucky.draw.my.times': 'Meus Tempos',
  'lucky.draw.rare': 'Cru',
  'lucky.draw.rules.1': 'Ao Final Do Evento, Os Três Primeiros Colocados Receberão Os Seguintes Prêmios:',
  'lucky.draw.rules.2': 'Observação: Ao Final Da Campanha, O Número De Prêmios Não Utilizados Será Zerado.',
  'lucky.draw.tab.ranking': 'Classificação',
  'lucky.packet.1': 'Enviar Pacote Da Sorte',
  'lucky.packet.10': '1. Pacote Da Sorte Com Senha\n- Você Precisa Enviar A Senha Para A Sala Para Pegá-Lo.',
  'lucky.packet.11': '2. O Pacote Da Sorte Exige Seguidores\n- Você Precisa Seguir O Remetente Do Pacote Da Sorte Para Recebê-Lo.',
  'lucky.packet.12': 'Problemas Comuns',
  'lucky.packet.13': '1. Quando O Pacote Aciona A Notificação Mundial Ou Quando O Ícone Do Pacote Da Sorte É Exibido, Outras Pessoas Podem Entrar Na Sua Sala Clicando Nele.',
  'lucky.packet.14': '2. Se Você Trancar Seu Quarto, A Notificação E O Ícone Do Mundo Não Aparecerão.',
  'lucky.packet.2': 'Todos Os Usuários Na Sala Podem Enviar E Reivindicar Pacotes Da Sorte.',
  'lucky.packet.3': 'Quando Há Muitos Pacotes Da Sorte Em Uma Sala, Eles São Empilhados E Exibidos. Quanto Mais Cedo Os Pacotes Da Sorte Forem Enviados, Mais Deles Ficarão Expostos No Topo.',
  'lucky.packet.4': 'Restrições E Condições',
  'lucky.packet.5': '1. Suporta Apenas O Envio De Moedas.',
  'lucky.packet.6': '2. Faixa de Pessoas: 3~500.',
  'lucky.packet.7': '3. A Quantidade Per Capita (Quantidade De Moedas/Número De Pessoas) Precisa Ser Maior Ou Igual A 1 Moeda.',
  'lucky.packet.8': '4. Quando O Valor Do Pacote For Superior A 10000 Moedas E O Número De Pessoas For Superior A 10, Será Acionada Uma Notificação Mundial E Um Ícone Especial Será Exibido Na Lista De Salas.',
  'lucky.packet.9': 'Como Jogar',
  'lucky.packet.title': 'Pacote Da Sorte',
  'lucky.recharge.draw.num': 'Meus Bilhetes De Rifa Disponíveis',
  'lucky.recharge.draw.record': 'Veja Meu Histórico De Vitórias',
  'lucky.recharge.draw.start': 'Loteria Inicial',
  'lucky.recharge.hide.info': 'Ocultar Informações Pessoais',
  'lucky.recharge.recharge.done': 'Você Ganhou Todos Os Bilhetes Da Roleta!',
  'lucky.recharge.recharge.gift.bag': 'Pacote De Recarga',
  'lucky.recharge.recharge.gift.bag.text': 'Recarregue {N} Todos Os Dias Para Obter',
  'lucky.recharge.recharge.gift.bag.text.1': 'Bilhete De Loteria Do Prêmio Acumulado*1',
  'lucky.recharge.recharge.next': 'Recarregue {N}<Div></Div> Para Ganhar {X} Bilhetes De Loteria',
  'lucky.recharge.recharge.no': 'Número Insuficiente De Bilhetes Para O Sorteio.',
  'lucky.recharge.recharged': 'Recarregado',
  'lucky.recharge.tab.grid': 'Fortune Price Pool',
  'lucky.recharge.tab.wheel': 'Roda Da Fortuna',
  'lucky.recharge.ticket': 'Sorteio\nBilhete',
  'lucky.recharge.wheel.tip.text.1': 'A Cada Recarga Que Você Atingir Um Determinado Valor, Você Ganha Um Bilhete De Loteria, Com 100% De Chance De Ganhar!',
  'lucky.recharge.wheel.tip.text.2': 'Quanto Mais Sorteios, Maior A Chance De Ganhar O Prêmio Principal!',
  'lucky.vs.camp.Eagle': 'Classificação Águia',
  'lucky.vs.camp.Lion': 'Ranking Do Leão',
  'lucky.vs.camp.edit.text.1': 'Acampamento De Mudança',
  'lucky.vs.camp.edit.text.2': 'Tem Certeza De Que Deseja Mudar De Acampamento? Cada Pessoa Só Pode Mudar De Acampamento Uma Vez.',
  'lucky.vs.camp.edit.text.3': 'Sim',
  'lucky.vs.camp.edit.text.4': 'Não',
  'lucky.vs.camp.join': 'Juntar',
  'lucky.vs.camp.me': 'Nosso Acampamento',
  'lucky.vs.camp.opponent': 'Campo Adversário',
  'lucky.vs.camp.select': 'Seleção De Acampamento',
  'lucky.vs.camp.select.text.1': 'Os 5 Melhores Colaboradores Dos Acampamentos Vencedores Podem Ganhar Moedas Como Recompensa!',
  'lucky.vs.camp.select.text.2': 'Em Qual Acampamento Você Quer Participar?',
  'lucky.vs.camp.select.text.3': 'Dicas: Cada Pessoa Só Pode Trocar De Acampamento Uma Vez Durante O Evento.',
  'lucky.vs.ext.text.tip': 'Ao Atingir {N} Moedas, Você Pode Obter As Seguintes Recompensas.',
  'lucky.vs.out.tab.left': 'Caixa Do Tesouro',
  'lucky.vs.out.tab.right': 'Águia Vs Leão',
  'lucky.vs.reward.extra': 'Bônus Águia Vs Leão',
  'lucky_daily': 'Diário',
  'lucky_faq1': 'Como Jogar',
  'lucky_faq10': '2. Ciclo Estatístico',
  'lucky_faq11': 'Classificação Diária: Dados Das 0:00 Às 24:00 De Cada Dia.',
  'lucky_faq12': 'Classificação Semanal: Dados Das 0H De Segunda-Feira Às 24H De Domingo.',
  'lucky_faq13': '3. Recompensas Por Classificação',
  'lucky_faq14': 'Os Dez Primeiros Colocados Nos Rankings Diário E Semanal Receberão Recompensas Conforme Mostrado Abaixo.',
  'lucky_faq15': 'Recompensas Diárias Por Classificação',
  'lucky_faq16': 'Classificação',
  'lucky_faq17': 'Recompensas Semanais De Classificação',
  'lucky_faq2': 'Regras Do Jogo',
  'lucky_faq3': '1. Após Oferecer Um Presente Da Sorte, Você Tem A Chance De Ganhar De 1 A 1000 Vezes O Valor Em Moedas De Ouro Como Recompensa;',
  'lucky_faq4': '2. Quanto Mais Presentes Da Sorte Você Enviar Em Combo Ou Lote, Maior Será A Chance De Ganhar;',
  'lucky_faq5': '3. As Moedas De Ouro Serão Distribuídas Para O Saldo Da Conta Em Tempo Real, E Os Detalhes Dos Ganhos Podem Ser Visualizados No Registro De Presentes Da Sorte;',
  'lucky_faq6': '4. Cada Vez Que Um Presente Da Sorte For Dado, O Apresentador Também Receberá Uma Certa Quantidade De Diamantes.',
  'lucky_faq7': 'Regras de Ranking',
  'lucky_faq8': '1. Regras Estatísticas',
  'lucky_faq9': 'Os Dez Usuários Que Gastarem Mais Moedas De Ouro Participando Dos Jogos Diários E Semanais Estarão No Ranking Dos Ricos, E Os Dez Usuários Com Os Maiores Multiplicadores De Ganhos Estarão No Ranking Dos Sortudos.',
  'lucky_list': 'Ranking da Sorte',
  'lucky_weekly': 'Semanalmente',
  'miss': 'Perdas',
  'missToday': 'Perdido Hoje',
  'modalBtn': 'Continuar A Conversar',
  'modalIncome': 'Taxa De Renda',
  'modalReward': 'Recompensas Extras',
  'modalRound': 'Rodadas De Bate-Papo',
  'modalSpeed': 'Velocidade De Resposta',
  'modalTips': 'Quanto Mais Rápido Você Responder Às Mensagens, Melhor Será A Experiência Do Usuário E Mais Diamantes Você Ganhará.',
  'modalTipsTwo': 'Quanto Maior A Qualidade Do Conteúdo Das Suas Respostas E Mais Rodadas De Bate-Papo, Melhor Será A Experiência Do Usuário E Mais Diamantes Você Ganhará:',
  'modalTipsThree': 'Quanto maior a qualidade das suas respostas, mais diamantes você ganha. Limite diário de recompensas extras: {%s}',
  'month': 'Mês',
  'month.select': 'Selecione O Mês',
  'month.select.day': 'Selecione A Data',
  'more': 'Mais',
  'my.earning.daimonds': 'Diamantes',
  'my.earning.salary.rules': 'Regras Salariais',
  'my.earning.tips': 'Equilíbrio De Diamante',
  'my.earning.title': 'Meus Ganhos',
  'my.earning.withdrawal.rules': 'Regras De Saque',
  'new.ranking.list.charm': 'Charme',
  'new.ranking.list.contribution': 'Contribuição',
  'new.ranking.list.record': 'Registro',
  'new.task.done': 'Feito',
  'new.task.go': 'Ir',
  'noble_introduce_1': '1. O Que É Aristocracia?',
  'noble_introduce_2': '2. Como Se Tornar Um Aristocrata',
  'noble_introduce_3': '3. Cálculo Do Período De Validade',
  'noble_introduce_4': '4. Instruções Diárias De Entrega De Moedas',
  'noble_introduce_5': '5. Descontos Para Compras Recorrentes',
  'noble_introduce_6': '6. Ascensão Da Aristocracia',
  'noble_introduce_7': '7. Enviar Aristocracia Como Presente',
  'noble_introduce_text1': 'A Aristocracia É Um Símbolo De Status Especial, Dividida Em Sete Níveis: Cavaleiro, Barão, Visconde, Conde, Marquês, Duque E Rei. Cada Nível Aristocrático Desfruta De Privilégios Distintos.',
  'noble_introduce_text2': 'A Aristocracia Pode Ser Adquirida Recarregando Moedas De Ouro, E A Compra Pode Ser Concluída Selecionando O Nível Correspondente Na Página Da Aristocracia. Ao Mesmo Tempo, Você Também Pode Obter O Status De Aristocrático Através De Presentes De Outros Jogadores.',
  'noble_introduce_text3': 'O Status Aristocrático É Válido Por 30 Dias A Partir Da Data Da Compra, E Você Desfrutará De Privilégios Aristocráticos Durante Esse Período. Os Privilégios Expirarão Ao Final Do Período De Validade.',
  'noble_introduce_text4': 'Após Adquirir Aristocracia Com Moedas De Ouro, Você Terá Direito A Receber Moedas De Ouro Como Presente Diariamente. Você Receberá Moedas De Ouro Após Fazer Login Todos Os Dias. Caso Não Faça Login Em Determinado Dia, Você Não Poderá Receber As Moedas De Ouro Referentes A Esse Dia. Ao Presentear Alguém Com Aristocracia, O Destinatário Receberá O Direito De Receber Moedas De Ouro Diariamente.',
  'noble_introduce_text5': 'Durante O Período De Vigência Do Status Aristocrático E Até 10 Dias Após O Seu Término, O Mesmo Status Poderá Ser Adquirido Novamente Por Um Preço Mais Vantajoso. Este Plano Não É Automático E Requer Compra Manual Para Entrar Em Vigor.',
  'noble_introduce_text6': 'Se Você Já Possui Status Aristocrático, Pode Adquirir Um Nível Aristocrático Superior E Obter Diretamente Os Benefícios Mais Recentes. Os Dias Restantes Do Seu Status Aristocrático Atual Serão Transferidos Para O Novo Nível, De Acordo Com O Saldo Restante, E O Período De Validade Do Novo Nível Aristocrático Será Estendido.',
  'noble_introduce_text7': 'Ao Conceder O Status De Aristocracia A Outra Pessoa, O Valor Original Será Repassado A Ela, E O Destinatário Desfrutará De Moedas Diárias E Outros Direitos Correspondentes Ao Nível. Se O Destinatário Já Possuir O Status De Aristocracia, Ele Passará A Desfrutar Diretamente Do Status De Aristocracia De Nível Superior, E Os Demais Níveis Serão Convertidos De Acordo Com A Duração Correspondente.',
  'noble_introduce_title': 'Introdução Às Regras Da Aristocracia',
  'noble_introduce_welcome': 'Bem-Vindo(A) Ao Nosso Sistema Aristocrático! Tornar-Se Um(A) Aristoctat Lhe Permitirá Desfrutar De Privilégios E Benefícios Exclusivos. A Seguir, Apresentamos Uma Breve Introdução Ao Nosso Sistema Aristocrático:',
  'payment_bind_1': 'Conta',
  'payment_bind_10': 'Exclusão Bem-Sucedida',
  'payment_bind_11': 'Nome Próprio/Nome De Batismo',
  'payment_bind_12': 'Sobrenome',
  'payment_bind_13': 'Endereço Do Contrato',
  'payment_bind_14': 'Epay Por E-Mail',
  'payment_bind_15': 'Nota: Protocolo Trc-20',
  'payment_bind_16': 'Observação: Certifique-Se De Que Sua Conta Epay Esteja Verificada.',
  'payment_bind_17': 'O Endereço Do Contrato Começa Com T.',
  'payment_bind_18': 'Não Pode Exceder 40 Caracteres.',
  'payment_bind_19': 'O E-Mail Deve Ser O Mesmo Da Sua Conta Epay.',
  'payment_bind_2': 'Cartão Bancário',
  'payment_bind_20': 'Insira O Endereço De E-Mail',
  'payment_bind_21': 'Conta Gcash',
  'payment_bind_22': 'Deve Ter 11 Dígitos, Começando Com 09.',
  'payment_bind_23': 'Permita Apenas Letras Do Alfabeto Inglês, Espaços, Hífens (-), Pontos (.) E Vírgulas (,) E Menos De 100 Caracteres.',
  'payment_bind_24': 'Conta De Transferência Bancária',
  'payment_bind_25': 'Pix Key (CPF/CNPJ)',
  'payment_bind_26': 'Documento',
  'payment_bind_27': 'Apenas 11 dígitos são permitidos',
  'payment_bind_2_GPAY': 'Cartão Bancário',
  'payment_bind_3': 'Nome Do Banco',
  'payment_bind_4': 'Nome',
  'payment_bind_5': 'Email',
  'payment_bind_6': 'Endereço',
  'payment_bind_7': '10 Dígitos Ou Pl Mais 10 Dígitos',
  'payment_bind_8': 'Começa Com Tr + 24 Dígitos',
  'payment_bind_9': '{n} Deve',
  'profit': 'Estatísticas De Renda',
  'program_faq_10': 'Todos Na Sala Podem Acessar A Programação Clicando No Canto Superior Direito E Demonstrar Apoio Aos Seus Programas Favoritos Clicando Em \"Tenho Interesse\" Ou \"Enviar Presente\" Para Aumentar A Popularidade Do Programa.',
  'program_faq_11': 'Exclua Um Programa Ou Feche A Programação.',
  'program_faq_12': 'O Proprietário Ou Administrador Da Sala Pode Deslizar Para A Esquerda Em Um Programa E Clicar Em \"Excluir\" Para Removê-Lo. A Programação Será Fechada Automaticamente Após 7 Dias, Mas O Anfitrião Ou Administrador Também Pode Fechá-La Manualmente. Excluir Um Programa Ou Fechar A Programação Apagará Os Dados De Popularidade Do Programa.',
  'program_faq_13': 'Pontas',
  'program_faq_13_ios': 'Pontas',
  'program_faq_14': '1. A Programação Permite A Inclusão De, No Máximo, 15 Programas.',
  'program_faq_15': '2. Um Cronograma De Programa Que Não Passou Na Revisão Não Pode Ser Aberto.',
  'program_faq_16': '3. A Programação Será Fechada Automaticamente Após 7 Dias De Sua Abertura.',
  'program_faq_2': 'Introdução À Programação',
  'program_faq_3': 'Para Aumentar A Diversão E A Interatividade, Oferecemos Um Recurso De Programação. A Programação Serve Como Uma Prévia Dos Próximos Programas Da Sala. Os Espectadores Podem Votar E Enviar Presentes Com Base Na Programação, Expressando Suas Preferências E Entusiasmo Pelos Programas Oferecidos.',
  'program_faq_4': 'Programação E Entrada',
  'program_faq_5': 'O Proprietário Ou Administrador Da Sala Pode Acessar A Programação Através Do Menu Configurações. Os Espectadores Podem Acessar A Programação Clicando No Canto Superior Direito Da Sala Quando A Transmissão Estiver Ao Vivo.',
  'program_faq_6': 'Como Elaborar Um Cronograma De Atividades',
  'program_faq_7': 'Clique Em \"Adicionar Programa\" E Digite O Nome Do Programa Que Deseja Executar.',
  'program_faq_8': 'Após Criar E Revisar A Programação, Clique Em \"Iniciar Programação\" Para Torná-La Visível Ao Público. Uma Vez Ativada, Os Espectadores Poderão Visualizar A Programação.',
  'program_faq_9': 'Como Interagir Com A Programação Do Programa',
  'program_faq_part1': 'Parte 1',
  'program_faq_part2': 'Parte 2',
  'program_faq_part3': 'Parte 3',
  'program_faq_part4': 'Parte 4',
  'program_list_24_ios': 'Excluir',
  'pull.refresh.activate': 'Solte Para Atualizar',
  'pull.refresh.deactivate': 'Puxe Para Atualizar',
  'pull.refresh.release': 'Carregando Mais',
  'push.refresh.activate': 'Carregando Mais',
  'push.refresh.noMore': 'Sem Mais Informações.',
  'quality': 'Qualidade Do Chat',
  'quickCall': 'Avaliações Do Usuário <br /> Para Chamada Rápida Com A Âncora',
  'quickCall1': 'Avaliações De Usuários <br /> Para Chamada Rápida Comigo',
  'ramadan.new.back': 'Voltar',
  'ramadan.new.bottom.desc': 'Recarregue Uma Vez Por Dia E Você Poderá Se Cadastrar Novamente.',
  'ramadan.new.collect': 'Coletar',
  'ramadan.new.collected': 'Coletado',
  'ramadan.new.estimated.win': 'Ganho Estimado',
  'ramadan.new.event.start': 'O Evento Está Prestes A Começar.',
  'ramadan.new.had.sign': 'Você Fez Login Novamente Hoje.',
  'ramadan.new.honor.countdown.ing': 'Contagem Regressiva',
  'ramadan.new.honor.countdown.over': 'O Evento Terminou.',
  'ramadan.new.honor.countdown.waiting': 'O Evento Está Prestes A Começar.',
  'ramadan.new.honor.desc': 'A Janela Pop-Up De Honra Do Quarto Será Acionada Uma Vez Para Cada {N} Presentes Limitados Em Todas As Plataformas.',
  'ramadan.new.honor.my.times': 'Meus Tempos',
  'ramadan.new.honor.time': '{N} Vezes',
  'ramadan.new.honor.times': '{N} Vezes',
  'ramadan.new.honor.toTop1.time': 'Precisa De <span class=\'span\'> {N} </span> Tempo',
  'ramadan.new.honor.toTop1.times': 'Necessidade De <span class=\'span\'> {N} </span> Vezes',
  'ramadan.new.my.tickets': 'Meus Ingressos',
  'ramadan.new.next': 'Próximo',
  'ramadan.new.nickname': 'Apelido',
  'ramadan.new.not.remain': 'Não Mostre Novamente.',
  'ramadan.new.ok': 'Ok',
  'ramadan.new.prize.content': 'Você Recebeu',
  'ramadan.new.rank.daily': 'Classificação Diária',
  'ramadan.new.rank.daily.desc': 'O Usuário Top1 Diário Pode Receber Recompensas Correspondentes.',
  'ramadan.new.rank.tab.give': 'Classificação De Riqueza',
  'ramadan.new.rank.tab.receive': 'Classificação Encantadora',
  'ramadan.new.rank.tips': 'Esta Etapa Está Prestes A Começar.',
  'ramadan.new.rank.total': 'Classificação Geral',
  'ramadan.new.resign.btn': 'Entrar Novamente',
  'ramadan.new.resign.content': 'A Renovação Bem-Sucedida Do Contrato Garante:',
  'ramadan.new.resign.fail.btn': 'Recarregue Agora',
  'ramadan.new.resign.fail.content': 'Recarregue Uma Vez Por Dia E Você Poderá Se Cadastrar Novamente Uma Vez. (Moedas Compradas De Revendedores Serão Contabilizadas; Compras Feitas Diretamente Na Plataforma Por Revendedores Não Serão Contabilizadas.)',
  'ramadan.new.sign.day': 'Faça Login Por {N} Dias',
  'ramadan.new.tab1': 'Inscrição Para O Ramadã',
  'ramadan.new.tab2': 'Classificação De Orações',
  'ramadan.new.tab3': 'Bênção Honra',
  'ramadan.new.today.content': 'Faça Login Hoje E Ganhe:',
  'ramadan.new.waiting': 'Esperando',
  'ranking.blank.daily': 'Ninguém Enviou Presentes Hoje.',
  'ranking.blank.weekly': 'Ninguém Enviou Presentes Esta Semana.',
  'ranking.contributed': 'Contribuiu:',
  'ranking.daily': 'Diário',
  'ranking.weekly': 'Semanalmente',
  're_signing': 'Renovação De Contrato',
  'reached': '🙋‍♀️ Número De Usuários',
  'recharge.event.Recharge': 'Recarregar',
  'recharge.event.amount.reached': 'Quantidade De Moedas Atingida',
  'recharge.event.done': 'Parabéns! Você Alcançou O Nível Mais Alto! Aproveite Suas Recompensas Agora Mesmo!',
  'recharge.event.group': 'Grupo',
  'recharge.event.hidden': 'Ocultar Informações',
  'recharge.event.next.1': 'Só Precisa',
  'recharge.event.next.2': 'Moedas Para Alcançar O Próximo Nível',
  'recharge.event.ranking.list': 'Lista De Classificação',
  'recharge.event.rewards.for': 'Recompensas Para',
  'recharge.event.tab.1': 'Progresso Da Recarga',
  'recharge.event.trouble': 'Você Está Tendo Problemas Para Recarregar?',
  'recharge.result.pending': 'Operação Concluída',
  'recharge.result.tips': 'Caso As Moedas Não Cheguem A Tempo, Não Se Preocupe, Pode Haver Atrasos Na Rede. Se Tiver Alguma Dúvida, Entre Em Contato Com O Atendimento Ao Cliente Oficial Da Soyou.',
  'recharge.result.tips.click': 'Clique Para Retornar Ao Aplicativo.',
  'retry': 'Tentar Novamente',
  'rich_list': 'Ranking De Ricos',
  'roundTitle': 'Regras De Renda Das Rodadas De Bate-Papo',
  'share.download': 'Download',
  'share.install': 'Instale Agora O Aplicativo Soundi Radio.',
  'share.live': 'Ao Vivo',
  'share.ok': 'Ok',
  'share.play': 'Ouça Na Soundi Radio',
  'share.whatsapp.tip': 'O Whatsapp Pode Não Estar Instalado No Seu Celular. Instale-O E Tente Novamente.',
  'share_text100': 'Copiado',
  'share_text23': 'Download',
  'share_text24': 'Entre Na Sala',
  'share_text25': 'Estou Nesta Sala, Venha Se Juntar A Nós.',
  'share_text26': 'Id Do Quarto',
  'sign_in_text3_new': 'Faça Login E Ganhe O Dobro Da Recompensa.',
  'speed': 'Velocidade De Resposta',
  'speed.passion.Completed': 'Concluído',
  'speed.passion.Daily.Rewards': 'Recompensas Diárias',
  'speed.passion.Done': 'Feito',
  'speed.passion.Result': 'Resultado',
  'speed.passion.Result.lose': 'Nenhuma Equipe Venceu Ontem, Então Vamos Tentar Novamente Hoje.',
  'speed.passion.Result.ps': 'Ps: Apenas O Mvp Do Grupo Vencedor Receberá Recompensas Extras!',
  'speed.passion.Result.win': 'Parabéns A {N} Por Ter Ficado Em Primeiro Lugar Ontem, Aceite Estas Recompensas!',
  'speed.passion.change': 'Mudar',
  'speed.passion.change.change.desc': 'Tem Certeza De Que Deseja Mudar Para Este Grupo?',
  'speed.passion.change.change.group': 'Alterar O Grupo',
  'speed.passion.change.change.ps': 'Ps: Todas As Recompensas Deste Grupo Ficarão Indisponíveis Após A Mudança De Grupo.',
  'speed.passion.choice.group': 'Selecionar Grupo',
  'speed.passion.choice.group.desc': 'Obtido Após Ingressar No Grupo',
  'speed.passion.daily.task': 'Tarefa Diária',
  'speed.passion.go.for.it': 'Vá Em Frente',
  'speed.passion.limited.desc': 'Usuários Com Nome Ganham {N}X Milhas Ao Enviar Seu Presente Com Nome.',
  'speed.passion.naming.desc': 'O Usuário Que Enviar Esse Presente Com Mais Frequência Durante O Evento Terá O Nome Dado A Ele Na Semana Seguinte!',
  'speed.passion.naming.progress': 'Progresso Chamado',
  'speed.passion.naming.progress.get.the.number': 'Obtenha O Número',
  'speed.passion.naming.progress.no.one.get': 'Ninguém Ainda Tem Acesso A Isso, Então Participe!',
  'speed.passion.naming.unnamed': 'Sem Nome',
  'speed.passion.race': 'Uma Corrida',
  'speed.passion.rank.Mileage': 'Quilometragem:',
  'speed.passion.rank.daily': 'Diário',
  'speed.passion.rank.no.rank': 'Meu Grupo',
  'speed.passion.rank.not.time': 'Ainda Não É A Hora.',
  'speed.passion.rank.total': 'Total',
  'speed.passion.ranking': 'Classificação',
  'speed.passion.winning.TOP1': 'Vencedor Do Top 1',
  'speedTitle': 'Responder À Mensagem Regras De Renda',
  'spring.cp.cruise.bless': 'Clique Para Abençoar',
  'spring.cp.cruise.bless.click.desc': 'Clique Em {N} Vezes Para Obter {name} {time}',
  'spring.cp.cruise.bless.my.times': 'Meus Tempos',
  'spring.cp.cruise.bless.status.1': 'Recebido',
  'spring.cp.cruise.bless.status.2': 'Não Reclamado',
  'spring.cp.cruise.find.my.cp': 'Encontre Meu Cp',
  'spring.cp.cruise.my.cp': 'Meu Cp',
  'spring.cp.cruise.rule.tips': 'A dupla de casal que ganhar o maior número de rosas trocando presentes limitados durante o evento poderá realizar um casamento no castelo em 15 de Fevereiro.',
  'spring.cp.no.cp': 'Você ainda não enviou presentes limitados do Dia dos Namorados para outras pessoas.',
  'spring.cp.no.people': 'Esperando',
  'spring.cp.rewards.wedding.tips': 'Os Dois Usuários Que Organizam O Casamento Podem Obter O Avatar Limitado Por 30 Dias.',
  'spring.cp.tab.cruise.ranking': 'Casamento Em Cruzeiro',
  'spring.cp.tab.rose.ranking': 'Classificação De Rosas',
  'spring.cp.tab.rose.ranking.daily': 'Classificação Diária',
  'spring.cp.tab.rose.ranking.daily.tips': 'Enviar Este Presente Pode Render {%D}% Rosas Extras Hoje.',
  'spring.cp.tab.rose.ranking.daily.toast': 'A Data Ainda Não Chegou.',
  'spring.cp.tab.rose.ranking.total': 'Classificação Geral',
  'spring.cp.wait.wedding': 'O casamento começará no dia 15 de Fevereiro.',
  'svip_introduce_1': '1. O Que É Svip?',
  'svip_introduce_2': '2. Como Se Tornar Um Svip',
  'svip_introduce_3': '3. Como Calcular O Período De Validade Do Svip',
  'svip_introduce_4': '4. Rebaixamento E Queda De Categoria Do Svip',
  'svip_introduce_5': '5. Direitos E Interesses Da Svip',
  'svip_introduce_text1': 'Svip É O Sistema De Níveis Diferenciados Da Plataforma. Existem 8 Níveis No Total, De Svip1 A Svip8. Quanto Maior O Nível, Mais Distinto O Status E Mais Direitos E Benefícios Exclusivos Você Terá.',
  'svip_introduce_text2': 'Você Pode Obter Pontos De Experiência Svip Recarregando Moedas De Ouro, Sendo 1 Moeda De Ouro = 1 Ponto De Experiência. Ao Atingir Diferentes Níveis De Svip, Você Poderá Desbloquear O Nível Svip Correspondente.',
  'svip_introduce_text31': 'O Svip Considera Cada Mês Como Um Ciclo, E No Dia 1º De Cada Mês, Os Pontos De Experiência Svip São Acumulados A Partir De 0. O Nível Svip Correspondente Será Obtido De Acordo Com O Nível Alcançado Pelo Valor De Experiência Svip.',
  'svip_introduce_text32': 'A Partir Do Momento Em Que Você Obtiver O Status Svip, Seu Status E Privilégios Serão Mantidos Até O Final Do Mês Seguinte. (Por Exemplo: Se O Nível Svip3 For Alcançado Em 18 De Maio, O Status Svip3 Será Estendido Até 30 De Junho.)',
  'svip_introduce_text33': 'Se O Seu Nível De Experiência Svip Atingir Um Nível Superior Dentro De Um Mês, Ele Será Atualizado Imediatamente. (Por Exemplo: Se Você Atingir O Nível Svip3 Em 18 De Maio E O Svip4 Em 25 De Maio, Você Obterá Imediatamente O Status Svip4 Em 25 De Maio E O Manterá Até O Final De 30 De Junho.)',
  'svip_introduce_text34': 'Ao Final Do Mês, A Identidade E Os Privilégios Serão Mantidos, Mas Os Pontos De Experiência Svip Para O Mês Seguinte Serão Acumulados A Partir De 0. (Por Exemplo: Se Você Atingir O Nível Svip4 Em 25 De Maio, Você Ainda Desfrutará Da Identidade E Dos Direitos De Svip4 Durante Todo O Mês De Junho, Mas Começará A Acumular Pontos De Experiência Svip A Partir De 0 Em Junho).',
  'svip_introduce_text41': 'No Início De Cada Mês, Se Você Possui Um Nível Svip E Deseja Mantê-Lo No Mês Seguinte, Precisa Atingir 50% Do Valor De Experiência Necessário Para Atingir Esse Nível Até O Final Do Mês. Para Isso, Você Poderá Manter O Nível, A Identidade E Os Direitos. (Por Exemplo: Se No Início De Maio Você For Svip4, Basta Atingir 50% Do Valor De Experiência Necessário Para Atingir Esse Nível Ao Longo De Maio Para Mantê-Lo Até O Final De Junho.)',
  'svip_introduce_text42': 'Se Você Não Atingir 50% Do Valor De Experiência Necessário Para O Nível Svip Em Um Mês, Seu Nível Será Reduzido Em 1 No Mês Seguinte. (Por Exemplo: No Início De Maio, Você É Svip4 E, Se O Valor De Experiência Acumulado Em Maio Não Atingir 50% Do Nível Svip4, Seu Nível Cairá 1 Em Junho, Começando Como Svip3.)',
  'svip_introduce_text43': 'Se Nenhum Ponto De Experiência Svip For Gerado Em Um Mês, Seu Nível Svip Cairá 3 Níveis No Mês Seguinte. (Por Exemplo: No Início De Maio, Você É Svip4 E Não Gera Nenhum Ponto De Experiência Durante O Mês De Maio; Em Junho, Seu Nível Cairá 3 Níveis, Começando Como Svip1).',
  'svip_introduce_text5': 'Quanto Maior O Nível Svip, Mais Direitos Você Terá. Quando O Nível Mudar, Você Desfrutará Dos Benefícios Do Novo Nível, E As Recompensas Em Itens Que Você Recebe Serão Substituídas Pelas Do Novo Nível. Ao Atualizar Ou Manter Itens Personalizados, Você Precisa Entrar Em Contato Com O Atendimento Ao Cliente E Apresentar Suas Necessidades De Personalização Antes Que Elas Sejam Emitidas. No Entanto, Elas Não Serão Emitidas Se Você Fizer Um Downgrade.',
  'svip_introduce_title': 'Introdução Às Regras Do Svip',
  'svip_introduce_welcome': 'Bem-Vindo(A) Ao Programa Svip! O Svip Lhe Dará Acesso A Mais Privilégios. A Seguir, Uma Breve Introdução Ao Svip:',
  'svip_table1': 'Nível Svip',
  'svip_table2': 'Mensagem Gratuita',
  'svip_table3': 'Chamadas Gratuitas',
  'task.center.common.level': 'Nível',
  'task.center.limit.Diamonds.Received': 'Diamantes Recebidos',
  'task.center.limit.Reward.Received': 'Recompensa Recebida',
  'task.center.limit.Total': 'Total',
  'task.center.limit.extra': 'Extra',
  'task.center.limit.receive': 'Receber',
  'task.center.limit.task': 'Tarefa Limitada',
  'task.center.limit.to.start': 'O Evento Ainda Não Começou.',
  'task.center.limit.today': 'Hoje',
  'task.center.normal.task': 'Tarefa Normal',
  'task.center.title': 'Central De Tarefas',
  'task_miss': 'Perder',
  'task_txt21': 'Check-In Diário',
  'task_txt22': 'Dia',
  'task_txt23': 'Entrar',
  'task_txt24': 'Lista De Tarefas',
  'task_txt25': 'Tarefas Âncora',
  'task_txt31': 'Assinado',
  'tips': 'Não Há Mais Dados',
  'to.exchange.page.button': 'Intercâmbio',
  'total.rank.daily': 'Diário',
  'total.rank.day': 'Diário',
  'total.rank.gap': 'Lacuna{X}',
  'total.rank.gift': 'Estrela<br />Semanal',
  'total.rank.help': '<h1>Tipo De Classificação<h1>\n<p>Classificação &lt;Sala&gt;: Durante O Período, Todos Os Quartos Serão Classificados De Acordo Com A Quantidade De Moedas Enviadas Como Presentes.</p>\n<p>Classificação &lt;Doador&gt;: Durante O Período, Todos Os Usuários Serão Classificados De Acordo Com A Quantidade De Moedas Enviadas Como Presentes.</p>\n<p>Classificação &lt;Encantador&gt;: Durante O Período, Todos Os Usuários Serão Classificados De Acordo Com A Quantidade De Moedas Recebidas Como Presentes.</p>\n<h1>Ciclo De Tempo Da Classificação</h1>\n<p>O Ciclo De Classificação Geralmente Dura Horas, Dias, Semanas E Meses.</p>\n<p>A Classificação Mostra Os 3 Melhores Do Ciclo Anterior, Bem Como Os 50 Melhores Do Ciclo Atual, Atualizados Em Tempo Real.\n(Com Um Atraso De Menos De 1 Minuto)</p>\n<p>Horário De Atualização (Utc+3): Atualização Diária Da Classificação Às 5H; Atualização Semanal Da Classificação Às 5H De Cada Segunda-Feira; Atualização Mensal Da Classificação Às 5H Do Dia 1º De Cada Mês.</p>\n<h1>Proteção De Privacidade</h1>\n<p>Algumas Classificações Não Mostrarão Números Específicos;</p>\n<p>No Entanto, A Diferença Entre As Classificações Anteriores Será Exibida;</p>\n<p>Os 3 Primeiros Colocados Não Mostrarão A Diferença Entre Si.</p>',
  'total.rank.help.eu': '<h1>Tipo De Classificação</h1>\n<p>Classificação &lt;Doador&gt;: Durante O Período, Todos Os Usuários Serão Classificados De Acordo Com A Quantidade De Moedas Que Receberam Como Presente.</p>\n<p>Classificação &lt;Encantador&gt;: Durante O Período, Todos Os Usuários Serão Classificados De Acordo Com A Quantidade De Moedas Que Receberam Como Presente.</p>\n<h1>Ciclo De Tempo Da Classificação</h1>\n<p>A Classificação Mostra Os 3 Melhores Do Ciclo Anterior, Bem Como Os 50 Melhores Do Ciclo Atual, Atualizados Em Tempo Real.\n(Com Um Atraso De Menos De 1 Minuto)</p>\n<p>Horário De Atualização (Utc+3): Atualização Diária Da Classificação Às 5H; Atualização Semanal Da Classificação Às 5H Todas As Segundas-Feiras; Atualização Mensal Da Classificação Às 5H Do Primeiro Dia De Cada Mês.</p>\n<h1>Proteção De Privacidade</h1>\n<p>Algumas Classificações Não Mostrarão Números Específicos; </p>\n<p>No Entanto, A Diferença Entre As Classificações Anteriores Será Exibida; </p>\n<p>Os 3 Primeiros Colocados Não Mostrarão A Diferença Entre Si.</p>',
  'total.rank.help.eu.ios.hide': '<h1>Ciclo De Tempo De Classificação</h1>\n<p>A Classificação Mostra Os 3 Primeiros Do Ciclo Anterior, Bem Como Os 50 Melhores Do Ciclo Atual, Atualizados Em Tempo Real.\n(Com Um Atraso De Menos De 1 Minuto)</p>\n<p>Horário De Atualização (Utc+3): Atualização Diária Da Classificação Às 5H; Atualização Semanal Da Classificação Às 5H Todas As Segundas-Feiras; Atualização Mensal Da Classificação Às 5H Do Primeiro Dia De Cada Mês.</p>\n<h1>Proteção De Privacidade</h1>\n<p>Algumas Classificações Não Mostrarão Números Específicos;</p>\n<p>No Entanto, A Diferença Entre As Classificações Anteriores É Exibida;</p>\n<p>As 3 Primeiras Não Mostrarão A Diferença Entre Si.</p>',
  'total.rank.help.title': 'Regras De Classificação',
  'total.rank.hide': 'Ocultar-Se No Ranking',
  'total.rank.hide.info': 'Informações Ocultas',
  'total.rank.hide.name': 'Senhor Mistério',
  'total.rank.hour': 'Por Hora',
  'total.rank.last.day': 'Último Dia Top3',
  'total.rank.last.hour': 'Top 3 Da Última Hora',
  'total.rank.last.month': 'Top 3 Do Mês Passado',
  'total.rank.last.week': 'Top 3 Da Semana Passada',
  'total.rank.month': 'Mensal',
  'total.rank.room': 'Sala',
  'total.rank.sent': 'Venenos',
  'total.rank.this.day': 'Neste Dia',
  'total.rank.this.hour': 'Esta Hora',
  'total.rank.this.month': 'Este Mês',
  'total.rank.this.week': 'Essa Semana',
  'total.rank.week': 'Semanalmente',
  'viewMore': 'Veja Mais',
  'vip.help.1': 'Regras Vip',
  'vip.help.10': 'Se O Seu Valor De Exp Acumulado Atingir Os Requisitos Para O Seu Nível Vip Atual Neste Mês, Você Manterá Seu Nível Vip No Próximo Mês; Caso Contrário, Seu Nível Vip Será Rebaixado No Próximo Mês. Por Exemplo: Se Você For Vip5 Em Maio, Mas Acumulou Apenas Vip3 Em Maio, Seu Nível Vip Será Rebaixado Para Vip3 A Partir De Junho.',
  'vip.help.11': 'Desconto De Nível Vip',
  'vip.help.12': 'Com Base No Nível Vip No Primeiro Dia De Cada Mês, Enviaremos Uma Certa Quantidade De Exp Vip Aos Usuários De Acordo Com Seus Níveis Vip No Primeiro Dia De Cada Mês.',
  'vip.help.13': 'Nível',
  'vip.help.14': 'Intervalo De Valores Exp',
  'vip.help.15': 'Desconto No Valor Exp',
  'vip.help.2': 'O Que É O Vip?',
  'vip.help.3': 'Vip É A Classe Especial Da Soyou. Ela Inclui 11 Níveis De Identificação. Você Terá Acesso Aos Privilégios Correspondentes Ao Se Tornar Vip.',
  'vip.help.4': 'Como Subir De Nível Vip?',
  'vip.help.5': '1. Recarregue $1 Para Ganhar 1 Exp Vip.</br>\n2. Seu Nível Vip Será Atualizado Imediatamente Quando A Exp Vip Atingir O Requisito De Atualização Naquele Mês.</br>\n3. A Partir Do Primeiro Dia De Cada Mês, A Exp Vip Inicial De Cada Pessoa Será Zerada. E Seu Nível Vip Será Definido Pela Quantidade De Exp Acumulada.',
  'vip.help.6': 'Regras Para Upgrade De Nível Vip',
  'vip.help.7': 'Regras De Atualização',
  'vip.help.8': 'Assim Que Você Atingir As Condições Para A Atualização Neste Mês, Seu Nível Vip Será Atualizado Imediatamente. E O Nível Vip Será Mantido Até O Final Do Mês Seguinte. Por Exemplo, O Usuário Atingiu O Nível Vip5 Em 10 De Março E Seu Nível Vip5 Permanecerá Até 30 De Abril.',
  'vip.help.9': 'Regras De Manutenção/Rebaixamento',
  'vip.help.update.info': 'O Sistema Vip Foi Atualizado. Sua Versão É Muito Antiga Para Visualizar Os Novos Recursos. Atualize Para A Versão Mais Recente E Aproveite A Nova Função Vip!',
  'vip.privileges.activate': 'Vip{N} Ativar',
  'vip.privileges.label.avatar': 'Moldura Exclusiva Para Mostrar Sua Identidade.',
  'vip.privileges.label.blockMessages': 'Bloqueie Mensagens De Estranhos E Não Seja Incomodado.',
  'vip.privileges.label.broadcast': 'Ao Atingir O Nível Vip8 Ou Superior, A Atualização Acionará Uma Notificação No Aplicativo.',
  'vip.privileges.label.bubble': 'O Balão De Bate-Papo Exclusivo Faz Com Que Sua Fala Se Destaque.',
  'vip.privileges.label.exclusivevehicles': 'Personalize Sua Montaria Exclusiva. Ao Atingir O Nível Vip11, Entre Em Contato Com O Atendimento Ao Cliente Para Obter Um Veículo Personalizado. Cada Usuário Tem Apenas Uma Chance De Personalizar.',
  'vip.privileges.label.follower': 'Você Pode Se Tornar Vip E Adicionar Mais Amigos. Quem Não É Vip Pode Seguir Até 1000 Pessoas. Vip 1 A 3 Aumenta O Número De Seguidores Em 1000, Vip 4 A 6 Em 2000 E Vip 7 E Acima Em 3000.',
  'vip.privileges.label.gif': 'Personalize Sua Moldura Dinâmica Exclusiva. Ao Atingir O Nível Vip9, Entre Em Contato Com O Atendimento Ao Cliente Para Obter Sua Moldura Dinâmica Personalizada. Cada Usuário Tem Apenas Uma Chance De Personalizá-La.',
  'vip.privileges.label.gift': 'Personalize Seu Presente Exclusivo. Ao Atingir O Nível Vip10, Entre Em Contato Com O Atendimento Ao Cliente Para Obter Presentes Personalizados. Cada Usuário Tem Apenas Uma Chance De Personalizar.',
  'vip.privileges.label.icon': 'O Selo Vip, Que Confere Um Caráter Exclusivo Aos Usuários Vip, Demonstra Sua Distinção.',
  'vip.privileges.label.id': 'Obtenha Seu Id Exclusivo E Seja Reconhecido À Primeira Vista! Vip8: Ababab (A E B Devem Ser Diferentes) Vip9: Aaabb (A E B Devem Ser Diferentes) Vip10: Abab (A E B Devem Ser Diferentes) Vip11: Aabb (A E B Devem Ser Diferentes) Nenhum Dos Formatos Pode Começar Com 0. Você Precisa Entrar Em Contato Com O Atendimento Ao Cliente Vip Para Obter Seu Id Exclusivo.',
  'vip.privileges.label.invisible': 'Permaneça Invisível E Esconda-Se Nas Recomendações De Outras Pessoas.',
  'vip.privileges.label.list': 'Exibição Prioritária Dos Resultados Da Pesquisa.',
  'vip.privileges.label.message': 'Você Pode Colocar As Conversas De Outros Usuários No Topo Da Lista De Mensagens.',
  'vip.privileges.label.name': 'Os Usuários Receberão Efeitos Especiais Para Decorar O Nome De Usuário.',
  'vip.privileges.label.open': 'Outros Usuários Poderão Ver Você Automaticamente Ao Abrir O Aplicativo, Uma Glória Inigualável! Ao Atingir O Nível Vip12, Entre Em Contato Com O Atendimento Ao Cliente Para Obter Uma Página Inicial Personalizada Por 24 Horas. Cada Usuário Tem Direito A Apenas Uma Personalização.',
  'vip.privileges.label.picture': 'A Opção De Enviar Imagens No Chat Do Bullet Journal.',
  'vip.privileges.label.privacy': 'Outras Pessoas Não Podem Pesquisar Você/Sua Sala De Voz.',
  'vip.privileges.label.protection': 'Nunca Se Preocupe Em Ser Desconectado Do Microfone Ou De Qualquer Sala.',
  'vip.privileges.label.rank': 'Você Pode Ativar O Botão [Ocultar Identidade] Para Aparecer Como Um Homem Misterioso Nos Rankings.',
  'vip.privileges.label.room': 'Cartão De Acesso Exclusivo Para Quarto Vip',
  'vip.privileges.label.sign': 'Os Membros Vip Podem Reivindicar Recompensas Em Dobro Por Check-In.',
  'vip.privileges.label.stealth': 'Ao Visitar Outros Usuários, Nenhum Histórico Será Registrado.',
  'vip.privileges.label.vehicle': 'Veículos Vip Exclusivos',
  'vip.privileges.label.visitor': 'Veja Todos Os Rastros De Visitantes Para Não Perder Nenhum Interessado Ou Fã.',
  'vip.privileges.stealth.close': 'Fechar',
  'vip.privileges.stealth.open': 'Abrir',
  'vip.privileges.stealth.text': 'Ocultar Meu Histórico De Acesso',
  'vip.privileges.title': 'Privilégios Vip',
  'vip.privileges.title.avatar': 'Moldura Vip',
  'vip.privileges.title.blockMessages': 'Modo Silencioso',
  'vip.privileges.title.broadcast': 'Notificação Do Aplicativo',
  'vip.privileges.title.bubble': 'Balão De Bate-Papo Vip',
  'vip.privileges.title.exclusivevehicles': 'Veículo Personalizado',
  'vip.privileges.title.follower': 'Limite Superior A Seguir.',
  'vip.privileges.title.gif': 'Quadro Dinâmico Personalizado',
  'vip.privileges.title.gift': 'Presentes Personalizados',
  'vip.privileges.title.icon': 'Etiqueta Vip',
  'vip.privileges.title.id': 'Id Exclusivo',
  'vip.privileges.title.invisible': 'Modo Invisível',
  'vip.privileges.title.list': 'Exibição Prioritária',
  'vip.privileges.title.message': 'Lista De Mensagens Principais',
  'vip.privileges.title.name': 'Destaque Do Nome De Usuário',
  'vip.privileges.title.open': 'Página Aberta Personalizada',
  'vip.privileges.title.picture': 'Mini Cartão Exclusivo Para Destacar Sua Honra.',
  'vip.privileges.title.privacy': 'Privacidade E Segurança',
  'vip.privileges.title.protection': 'Impedir A Remoção',
  'vip.privileges.title.rank': 'Ocultar Identidade',
  'vip.privileges.title.room': 'Cartão Mini Vip',
  'vip.privileges.title.sign': 'Recompensas De Check-In Vip',
  'vip.privileges.title.stealth': 'Visita Invisível',
  'vip.privileges.title.vehicle': 'Veículo Vip',
  'vip.privileges.title.visitor': 'Vestígios De Visita',
  'vip.privileges.update.info': 'O Sistema Vip Foi Atualizado. Sua Versão É Muito Antiga Para Visualizar Os Novos Recursos. Atualize Para A Versão Mais Recente E Aproveite A Nova Função Vip!',
  'vip_introduce_1': '1. O Que É Vip?',
  'vip_introduce_2': '2. Como Se Tornar Um Vip',
  'vip_introduce_3': '3. Período De Validade Vip',
  'vip_introduce_4': '4. Utilização De Adereços Vip',
  'vip_introduce_text1': 'Vip É Um Sistema De Progressão De Usuários. Atualmente, Existem 16 Níveis, De Vip1 A Vip16. Quanto Maior O Nível Vip, Mais Direitos Você Terá E Mais Recompensas Receberá.',
  'vip_introduce_text2': 'Você Pode Obter Pontos De Experiência Vip Recarregando Moedas De Ouro. 1 Moeda De Ouro = 1 Ponto De Experiência. Quanto Mais Moedas De Ouro Você Recarregar, Mais Pontos De Experiência Você Ganha E Mais Alto Será Seu Nível Vip.',
  'vip_introduce_text3': 'Uma Vez Obtido O Status Vip, Ele É Válido Permanentemente E Os Pontos De Experiência Vip São Acumulados Permanentemente, Sem Serem Zerados. Conforme Os Pontos De Experiência Aumentam, Você Será Promovido Para Um Nível Vip Superior E Desfrutará De Mais Benefícios.',
  'vip_introduce_text4': 'Os Itens Vip Que Você Obtiver Ficarão Sempre Armazenados Em Sua Mochila E Poderão Ser Usados ​​A Qualquer Momento. Ao Fazer Um Upgrade, Os Itens De Nível Inferior Que Você Já Possui Ainda Poderão Ser Usados.',
  'vip_introduce_title': 'Introdução Às Regras Vip',
  'vip_introduce_welcome': 'Bem-Vindo Ao Mundo Vip! Com O Programa Vip, Você Terá Acesso A Ainda Mais Privilégios. A Seguir, Uma Breve Introdução Ao Programa Vip:',
  'vip_table1': 'Nível Vip',
  'voiceChat': 'Avaliações Do Usuário <br /> Para Bate-Papo Por Voz Com O Âncora',
  'voiceChat1': 'Avaliações Do Usuário <br /> Para Bate-Papo Por Voz Comigo',
  'withdraw_text_0': 'Renda',
  'withdraw_text_1': 'Equilíbrio',
  'withdraw_text_10': 'Diamante:',
  'withdraw_text_11': 'Agendar:',
  'withdraw_text_12': 'Em Análise.',
  'withdraw_text_13': 'Saque Realizado Com Sucesso',
  'withdraw_text_14': 'A Tentativa De Retirada Falhou',
  'withdraw_text_15': 'Motivo Da Falha',
  'withdraw_text_16': 'Exibir Apenas Registros Dos Últimos 3 Meses',
  'withdraw_text_2': 'Retirar',
  'withdraw_text_21': 'Valor Do Saque',
  'withdraw_text_22': 'Diamantes Deduzidos',
  'withdraw_text_23': 'Método De Pagamento:',
  'withdraw_text_24': 'Adicionar Método De Pagamento',
  'withdraw_text_25': 'Retire Imediatamente',
  'withdraw_text_26': 'Por Favor, Verifique Se As Informações De Pagamento Estão Corretas. Informações Incorretas Resultarão Na Falha Do Saque E Taxas Adicionais Serão De Responsabilidade Do Usuário.',
  'withdraw_text_27': 'Pergunta De Feedback',
  'withdraw_text_28': 'Contate O Serviço De Atendimento Ao Cliente',
  'withdraw_text_29': 'Dica:',
  'withdraw_text_3': 'Intercâmbio',
  'withdraw_text_30': '1. É Permitido Efetuar, No Máximo, Um Saque Por Dia.',
  'withdraw_text_31': '2. Você Precisa Concluir A Autenticação De Pessoa Física E Vincular O Método De Pagamento Antes De Iniciar Um Saque.',
  'withdraw_text_32': '3. A Plataforma Não Cobra Nenhuma Taxa. A Taxa De Serviço É Deduzida Pelo Canal. As Taxas De Serviço Variam De Acordo Com O Canal. Entre Em Contato Com O Atendimento Ao Cliente Do Canal Para Obter Mais Detalhes.',
  'withdraw_text_33': '4. O Progresso Do Saque Pode Ser Visualizado Em \"Registro De Saques\".',
  'withdraw_text_34': '5. Caso O Saque Falhe, Os Diamantes Serão Devolvidos.',
  'withdraw_text_35': '6. Os Pedidos De Cancelamento Serão Processados ​​Em 7 A 14 Dias Úteis (Com Prorrogação Em Feriados).',
  'withdraw_text_36': 'Deve Ser Preenchido',
  'withdraw_text_37': '1. Autenticação De Pessoa Real',
  'withdraw_text_38': '2. Adicionar Método De Pagamento',
  'withdraw_text_39': 'Vincular',
  'withdraw_text_4': 'Registro De Saques',
  'withdraw_text_40': 'Verificar',
  'withdraw_text_42': 'Nenhum Método De Pagamento Aceito',
  'withdraw_text_43': 'Existem Pedidos Inacabados Para Este Método De Pagamento, Que Não Podem Ser Modificados Ou Excluídos Temporariamente.',
  'withdraw_text_44': 'Enviado Com Sucesso!',
  'withdraw_text_45': 'Tempo De Submissão',
  'withdraw_text_46': 'O Valor Será Creditado Em Sua Conta Em Até 5 Dias Úteis. Você Pode Acompanhar O Andamento Do Seu Saque No Histórico De Pagamentos.',
  'withdraw_text_47': 'Completo',
  'withdraw_text_48': 'Método De Pagamento',
  'withdraw_text_5': 'Equilíbrio De Diamantes Insuficiente',
  'withdraw_text_59': 'Atualizar',
  'withdraw_text_6': 'Consiga Mais Diamantes',
  'withdraw_text_7': 'Número Do Pedido:',
  'withdraw_text_8': 'Canal:',
  'withdraw_text_9': 'Quantia:',
  'world.cup.records': 'Registros',
  'world.cup.time': 'Tempo',
  'terms.help': 'Problemas com o App',
  'terms.bug': 'Bug',
  'terms.suggestions': 'Sugestões',
  'contacts.whatsapp': 'WhatsApp',
  'contacts.email': 'Email',
  'contacts.phone': 'Telefone',
  'submit.success': 'Obrigado pelo seu feedback',
  'terms.title': 'Categoria',
  'details.placeholder': 'Descreva os detalhes do seu problema',
  'contacts.title': 'Como entrar em contato com você?',
  'contact.placeholder': 'Deixe seus dados de contato',
  'submit.btn': 'Enviar',
  'country.select.hot': 'Populares',
  'country.select.all': 'Todos',
  'feedback.details': 'Detalhes',
  'feedback.screenshot': 'Captura de Tela (Opcional)',
  'feedback.title': 'Feedback',
  'subTitle': 'Não confie em outros canais de recarga além dos comerciantes verificados.',
  'chat': 'Chat',
  'id': 'SOYO ID',
  'contact': 'Contato',
  'whatsapp': 'WhatsApp',
  'right': 'A Equipe SOYO reserva-se o direito de interpretação final.',
  'check': 'A senha deve conter 8 caracteres, incluindo números, letras maiúsculas e minúsculas',
  'same': 'Digite a mesma senha',
  'copied': 'Copiado',
  'order.record.title': 'Registro',
  'order.record.failed': 'Recarga Falhou',
  'order.record.recharging': 'Recarregando',
  'order.record.succeeded': 'Recarga concluída',
  'order.record.order.id': 'ID do pedido: {id}',
  'order.record.channel': 'Canal: {name}',
  'about.title': 'Sobre',
  'Return Policy': 'Política de Devolução',
  'Intellectual Property Rights': 'Direitos de Propriedade Intelectual',
  'Contact Us': 'Contate-Nos',
  'About Us': 'Sobre Nós',
  'Supported Payment Methods': 'Métodos de Pagamento Suportados',
  'retirar.rules.title': 'Regras de Saque',
  'retirar.rules.rules.1': '1.Antes de usar o serviço de saque, é necessário enviar informações de identidade reais para garantir a segurança da conta.',
  'retirar.rules.rules.2': '2.Por favor, forneça informações de identidade reais, que serão usadas como base para a identificação e a determinação do direito de uso da sua conta.',
  'retirar.rules.rules.3': '3.As informações de identidade que você enviar serão mantidas estritamente confidenciais e não serão usadas para outros fins.',
  'retirar.rules.chat': 'Contatar Atendimento ao Cliente',
  'retirar.rules.important': 'Destaque:',
  'retirar.rules.rules.extra': '4.Entre em contato com o Atendimento ao Cliente quando precisar usar o serviço de saque e forneça as seguintes informações:',
  'retirar.rules.rules.extra.1': 'Nome real',
  'retirar.rules.rules.extra.2': 'Número do WhatsApp',
  'retirar.rules.rules.extra.3': 'Documentos de identidade (cartão de identidade, passaporte, etc.)',
  'retirar.rules.rules.extra.4': 'Seu método de pagamento (Transferência Bancária, Payoneer, Fawry, etc.)',
  'income.rules.rules.1': '1.Regras de Pagamento: As 00:00 do 16º dia de cada mês e do 1º dia do mês seguinte, o valor será deduzido do saldo de diamantes da conta.',
  'income.rules.rules.2': '2.Razão de Pagamento: 1 USD = 0 diamantes.',
  'income.rules.rules.3': '3.Horário de Liquidação: ① 00:00 do 16º dia de cada mês ② 00:00 do 1º dia do mês seguinte.',
  'income.rules.rules.4': '4.Settlement Period: 7~14 working days(holidays are postponed)',
  'income.rules.chat': 'Contatar Atendimento ao Cliente',
  'income.rules.important': 'Destaque:',
  'income.rules.title': 'Regras de Salário',
  'income.rules.rules.extra': 'Será notificado via \"Equipe\" quando o pagamento for liquidado. Os detalhes da dedução de diamantes podem ser consultados em \"Renda\". Acompanhe as notificações da Equipe. A liquidação normal será concluída em 7-14 dias úteis. Em caso de feriados, o prazo de liberação bancário será adiado. Agradecemos sua paciência. Se houver dúvidas, entre em contato com o Atendimento ao Cliente. Obrigado pelo seu suporte',
  'income.rules.usd': 'USD',
  'income.rules.diamonds': 'Diamantes',
  'home.recharge': 'Recarga',
  'home.slogan': 'Encontre seu alma gêmea aqui <br />Sempre com você',
  'home.download': 'Download',
  'recharge.result.success': 'Pagamento Bem-Sucedido',
  'recharge.result.error': 'Pagamento Falhou',
  'recharge.result.jumping_to_app': 'Redirecionando para o App...',
  'recharge.result.app_not_installed': 'App não instalado',
  'recharge.result.download_app_tip': 'Baixe e instale o app para continuar',
  'report.option.Porn': 'Pornografia',
  'report.option.Spam': 'Spam',
  'report.option.Fraud': 'Fraude',
  'report.option.Violence': 'Violência',
  'report.option.Illegal': 'Ilegal',
  'report.option.Other': 'Outros',
  'report.option.room': 'Não gosto disso',
  'report.option.user': 'Não gosto do usuário',
  'report.reason': 'Categoria',
  'report.details': 'Detalhes',
  'report.details.placeholder': 'Descreva os detalhes da sua denúncia',
  'report.screenshot': 'Captura de Tela (Opcional)',
  'report.submit': 'Enviar',
  'report.submit.success': 'Denúncia Enviada com Sucesso',
  'report.room': 'Denunciar',
  'report.user': 'Denunciar Usuário',
  'payment_bind_28': 'Tipo de conta',
  'payment_bind_29': 'PAYPAL_ID',
  'payment_bind_30': 'Account Number',
  'payment_bind_32': 'Phone number',
  'payment_bind_33': 'Must be 12 digits starting with 2541 or 2547',
  'payment_bind_34': 'Escolher Banco',
  'payment_bind_35': 'Pesquisar Banco',
  'payment_bind_36': 'Nome da conta',
  'payment_bind_37': 'Apenas números, sem espaços ou caracteres especiais',
  'payment_bind_38': 'Deve ter 9 ou 10 dígitos e não pode começar com 233',
  'payment_bind_39': 'Deve ser um e-mail válido com @, sufixo de pelo menos 2 caracteres, sem espaços',
  'payment_bind_40': 'Deve ter exatamente 10 dígitos, apenas números, sem espaços ou caracteres especiais',
  'payment_bind_41': "Apenas letras em inglês, números, espaços e apóstrofos ('), deve começar com uma letra",
  'family_text_116': 'Recomendar',
  'family_text_117': 'Ranking',
  'family_text_97': 'Hoje',
  'family_text_98': 'Mensal',
  'family_text_108': 'Ontem',
  'family_text_69': 'Mês Passado',
  'family_text_95': 'Popular',
  'family_text_96': 'Novo',
  'family_text_68': 'Este Mês',
  'family_toast_03': 'Juntar',
  'family_toast_04': 'Em Revisão',
  'family_toast_05': 'Entrou Para A Família Com Sucesso.',
  'family_toast_02': 'O Pedido Foi Enviado, Aguarde A Aprovação.',
  'family_toast_08': 'Criar Família',
  'family_enter': 'Família',
  'specialoffer_9': 'Oferta Especial',
  'specialoffer_10': '{%s} Moedas',
  'rewardboost_24': 'Nenhuma oferta especial disponível.',
  'Noble_Change_5_METR': 'Exemplo: Se Você É Atualmente Um Visconde (499950 Moedas/Mês), Com 13 Dias Restantes, E Comprar Um Conde (999950 Moedas/Mês) Hoje, Então, Após O Pagamento, O Período De Validade Do Conde Será De 13 * (499950/999950) + 30 = 6,5 Arredondado Para Baixo + 30 = 36 Dias.',
  'Noble_Change_5_TR': 'Exemplo: Se Você É Atualmente Um Visconde (499950 Moedas/Mês), Com 13 Dias Restantes, E Comprar Um Conde (999950 Moedas/Mês) Hoje, Então, Após O Pagamento, O Período De Validade Do Conde Será De 13 * (499950/999950) + 30 = 6,5 Arredondado Para Baixo + 30 = 36 Dias.',
  'Noble_Change_5_ME': 'Exemplo: Se Você É Atualmente Um Visconde (999900 Moedas/Mês), Com 13 Dias Restantes, E Comprar Um Conde (1999900 Moedas/Mês) Hoje, Então, Após O Pagamento, O Período De Validade Do Conde Será De 13 * (999900/1999900) + 30 = 6,5 Arredondado Para Baixo + 30 = 36 Dias.',
  'lucky.packet.7_TR': '3. A Quantidade Per Capita (Quantidade De Moedas/Número De Pessoas) Precisa Ser Maior Ou Igual A 5 Moeda.',
  'lucky.packet.7_ME': '3. A Quantidade Per Capita (Quantidade De Moedas/Número De Pessoas) Precisa Ser Maior Ou Igual A 10 Moeda.',
  'lucky.packet.8_TR': '4. Quando O Valor Do Pacote For Superior A 50000 Moedas E O Número De Pessoas For Superior A 10, Será Acionada Uma Notificação Mundial E Um Ícone Especial Será Exibido Na Lista De Salas.',
  'lucky.packet.8_ME': '4. Quando O Valor Do Pacote For Superior A 100000 Moedas E O Número De Pessoas For Superior A 10, Será Acionada Uma Notificação Mundial E Um Ícone Especial Será Exibido Na Lista De Salas.',
  'detail_recharge': 'Recarregar',
  'detail_chat': 'Bater papo',
  'detail_gift': 'Presente',
  'detail_game': 'Jogo',
  'detail_rewards': 'Recompensas',
  'detail_other': 'Outro',
  'detail_return': 'Retornar',
  'cp_ranking_total': 'Total',
  'cp_ranking_longest': 'CP mais longo',
  'cp_ranking_title': 'Classificação CP',
};

export default PT;
